/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Represents non-fractional signed whole numeric values. Since the value may exceed the size of a 32-bit integer, it's encoded as a string. */
  BigInt: { input: any; output: any; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
};

export type Ability = {
  __typename?: 'Ability';
  action: Array<Scalars['String']['output']>;
  limitingIds?: Maybe<Array<Scalars['Int']['output']>>;
  subject: Array<Scalars['String']['output']>;
};

export type Account = {
  __typename?: 'Account';
  accountType?: Maybe<Scalars['String']['output']>;
  campaigns?: Maybe<Array<Campaign>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  owner: User;
  paySubscription: PaySubscription;
  paySubscriptionId: Scalars['Int']['output'];
  teamMembers?: Maybe<Array<TeamMember>>;
  twilioSubaccount?: Maybe<TwilioSubaccount>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  wpBlogs?: Maybe<Array<WpBlog>>;
};


export type AccountWpBlogsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountCreated = {
  __typename?: 'AccountCreated';
  id?: Maybe<Scalars['String']['output']>;
  jwt?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AccountCreation */
export type AccountCreationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

/** Autogenerated return type of AccountCreation. */
export type AccountCreationPayload = {
  __typename?: 'AccountCreationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  user?: Maybe<AccountCreated>;
};

/** Autogenerated input type of ActiveAccountUpdate */
export type ActiveAccountUpdateInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ActiveAccountUpdate. */
export type ActiveAccountUpdatePayload = {
  __typename?: 'ActiveAccountUpdatePayload';
  activeAccount?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of AddEmailToAnonymousUser */
export type AddEmailToAnonymousUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of AddEmailToAnonymousUser. */
export type AddEmailToAnonymousUserPayload = {
  __typename?: 'AddEmailToAnonymousUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddPriceToSubscription */
export type AddPriceToSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  productName: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  wordpressUserId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of AddPriceToSubscription. */
export type AddPriceToSubscriptionPayload = {
  __typename?: 'AddPriceToSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AnonymousUser = {
  __typename?: 'AnonymousUser';
  bypassLimits?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  dacRequestCount?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mirRequestCount?: Maybe<Scalars['Int']['output']>;
  mirResetDate?: Maybe<Scalars['ISO8601Date']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AuditCampaign = {
  __typename?: 'AuditCampaign';
  allow?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Int']['output']>;
  blockedDelta?: Maybe<Scalars['Int']['output']>;
  broken?: Maybe<Scalars['Int']['output']>;
  brokenDelta?: Maybe<Scalars['Int']['output']>;
  crawlSubdomains?: Maybe<Scalars['Boolean']['output']>;
  crawledPages?: Maybe<Scalars['Int']['output']>;
  crawledPagesDelta?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  disallow?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  haveIssues?: Maybe<Scalars['Int']['output']>;
  haveIssuesDelta?: Maybe<Scalars['Int']['output']>;
  healthy?: Maybe<Scalars['Int']['output']>;
  healthyDelta?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  lastAudit?: Maybe<Scalars['ISO8601DateTime']['output']>;
  nextAudit?: Maybe<Scalars['ISO8601DateTime']['output']>;
  notify?: Maybe<Scalars['Boolean']['output']>;
  pageLimit?: Maybe<Scalars['Int']['output']>;
  pagesCrawled?: Maybe<Scalars['Int']['output']>;
  pagesCrawledDelta?: Maybe<Scalars['Int']['output']>;
  redirected?: Maybe<Scalars['Int']['output']>;
  redirectedDelta?: Maybe<Scalars['Int']['output']>;
  removedParameters?: Maybe<Scalars['String']['output']>;
  respectCrawlDelay?: Maybe<Scalars['Boolean']['output']>;
  scheduleDay?: Maybe<Scalars['Int']['output']>;
  seoProjectId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userAgentType?: Maybe<Scalars['Int']['output']>;
};

export type AuditSnapshot = {
  __typename?: 'AuditSnapshot';
  auditCampaignId: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  errorCount: Scalars['Int']['output'];
  errorDelta?: Maybe<Scalars['Int']['output']>;
  failures?: Maybe<Scalars['JSON']['output']>;
  finishDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  formattedErrors: Array<AuditSnapshotFormattedIssue>;
  formattedNotices: Array<AuditSnapshotFormattedIssue>;
  formattedWarnings: Array<AuditSnapshotFormattedIssue>;
  health: Scalars['Int']['output'];
  healthDelta: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  newErrors?: Maybe<Scalars['JSON']['output']>;
  noticeCount: Scalars['Int']['output'];
  noticeDelta?: Maybe<Scalars['Int']['output']>;
  notices?: Maybe<Scalars['JSON']['output']>;
  pagesCrawled?: Maybe<Scalars['Int']['output']>;
  quality?: Maybe<Scalars['JSON']['output']>;
  snapshotId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  warningCount: Scalars['Int']['output'];
  warningDelta?: Maybe<Scalars['Int']['output']>;
  warnings?: Maybe<Scalars['JSON']['output']>;
};

export type AuditSnapshotFormattedIssue = {
  __typename?: 'AuditSnapshotFormattedIssue';
  checks: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  delta: Scalars['Int']['output'];
  details: Array<AuditSnapshotFormattedIssueDetail>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  infoColumn: Scalars['String']['output'];
  issueId: Scalars['String']['output'];
  new: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  titlePage: Scalars['String']['output'];
  urlColumn: Scalars['String']['output'];
};

export type AuditSnapshotFormattedIssueDetail = {
  __typename?: 'AuditSnapshotFormattedIssueDetail';
  discovered: Scalars['ISO8601DateTime']['output'];
  hidden?: Maybe<Scalars['Boolean']['output']>;
  info?: Maybe<Scalars['JSON']['output']>;
  num: Scalars['Int']['output'];
  pageId: Scalars['String']['output'];
  sourceUrl: Scalars['String']['output'];
  targetUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Backlink = {
  __typename?: 'Backlink';
  anchor?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  externalNum: Scalars['Int']['output'];
  firstSeen?: Maybe<Scalars['ISO8601DateTime']['output']>;
  form: Scalars['Boolean']['output'];
  frame: Scalars['Boolean']['output'];
  image: Scalars['Boolean']['output'];
  imageAlt?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  internalNum: Scalars['Int']['output'];
  lastSeen?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lostlink: Scalars['Boolean']['output'];
  newlink: Scalars['Boolean']['output'];
  nofollow: Scalars['Boolean']['output'];
  pageAscore: Scalars['Int']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  responseCode?: Maybe<Scalars['Int']['output']>;
  sitewide: Scalars['Boolean']['output'];
  sourceSize?: Maybe<Scalars['Int']['output']>;
  sourceTitle?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  targetTitle?: Maybe<Scalars['String']['output']>;
  targetUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type BacklinkOverview = {
  __typename?: 'BacklinkOverview';
  authorityScore: Scalars['Int']['output'];
  backlinkTotal: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  date: Scalars['ISO8601Date']['output'];
  followed: Scalars['Int']['output'];
  form: Scalars['Int']['output'];
  frame: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  image: Scalars['Int']['output'];
  ipClassic: Scalars['Int']['output'];
  ips: Scalars['Int']['output'];
  notFollowed: Scalars['Int']['output'];
  referringDomainTotal: Scalars['Int']['output'];
  referringDomains: Scalars['Int']['output'];
  sponsored: Scalars['Int']['output'];
  text: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userGeneratedContent: Scalars['Int']['output'];
};

export type BacklinkOverviewReport = {
  __typename?: 'BacklinkOverviewReport';
  backlinkOverview?: Maybe<BacklinkOverview>;
  errors?: Maybe<Array<ErrorDetail>>;
};

export type BacklinkProfileReport = {
  __typename?: 'BacklinkProfileReport';
  backlinkOverview?: Maybe<WpBlogBacklinkOverview>;
  backlinkOverviewChanges?: Maybe<WpBlogBacklinkOverviewChanges>;
};

export type BacklinkReport = {
  __typename?: 'BacklinkReport';
  backlinks?: Maybe<Array<Backlink>>;
  errors?: Maybe<Array<ErrorDetail>>;
};

export type BlockedNumber = {
  __typename?: 'BlockedNumber';
  accountId: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  phoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of BlockedNumberCreate */
export type BlockedNumberCreateInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

/** Autogenerated return type of BlockedNumberCreate. */
export type BlockedNumberCreatePayload = {
  __typename?: 'BlockedNumberCreatePayload';
  blockedNumber?: Maybe<BlockedNumber>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
};

/** Autogenerated input type of BlockedNumberDestroy */
export type BlockedNumberDestroyInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

/** Autogenerated return type of BlockedNumberDestroy. */
export type BlockedNumberDestroyPayload = {
  __typename?: 'BlockedNumberDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  success: Scalars['Boolean']['output'];
};

export type Bundle = {
  __typename?: 'Bundle';
  bundleMarketingEvents: Array<BundleMarketingEvent>;
  bundleMarketingLineItems: Array<BundleMarketingLineItem>;
  confirmationUrl: Scalars['String']['output'];
  coupon?: Maybe<Coupon>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creationOnly: Scalars['Boolean']['output'];
  customerType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  keapMarketingEvents: Array<BundleMarketingEvent>;
  nonCheckoutOneTimeCoupon?: Maybe<Coupon>;
  nonCheckoutRecurringCoupon?: Maybe<Coupon>;
  prices: Array<Price>;
  slug: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  total: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type BundleMarketingEvent = {
  __typename?: 'BundleMarketingEvent';
  bundleId?: Maybe<Scalars['Int']['output']>;
  creationOnly?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  thirdParty?: Maybe<Scalars['String']['output']>;
};

export type BundleMarketingEventInput = {
  creationOnly: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  thirdParty: Scalars['String']['input'];
};

export type BundleMarketingLineItem = {
  __typename?: 'BundleMarketingLineItem';
  bundleId: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Campaign = {
  __typename?: 'Campaign';
  accountId: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  crmId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<TwilioNumber>;
  purpose?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  wpBlog?: Maybe<WpBlog>;
};

/** Autogenerated input type of CampaignChildrenEdit */
export type CampaignChildrenEditInput = {
  campaignId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumberId?: InputMaybe<Scalars['Int']['input']>;
  wpBlogId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CampaignChildrenEdit. */
export type CampaignChildrenEditPayload = {
  __typename?: 'CampaignChildrenEditPayload';
  campaign: Campaign;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CampaignEdit */
export type CampaignEditInput = {
  campaignId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CampaignEdit. */
export type CampaignEditPayload = {
  __typename?: 'CampaignEditPayload';
  campaign: Campaign;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CancelSubscriptionAtPeriodEnd */
export type CancelSubscriptionAtPeriodEndInput = {
  cancelAtPeriodEnd: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  wordpressUserId: Scalars['Int']['input'];
};

/** Autogenerated return type of CancelSubscriptionAtPeriodEnd. */
export type CancelSubscriptionAtPeriodEndPayload = {
  __typename?: 'CancelSubscriptionAtPeriodEndPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CarrotCrmConfig = {
  __typename?: 'CarrotCrmConfig';
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentUsers: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  maxUsers: Scalars['Int']['output'];
  planType: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId: Scalars['Int']['output'];
};

/** Autogenerated input type of CarrotCrmOptInUser */
export type CarrotCrmOptInUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CarrotCrmOptInUser. */
export type CarrotCrmOptInUserPayload = {
  __typename?: 'CarrotCrmOptInUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<ErrorDetail>;
  success: Scalars['Boolean']['output'];
};

export type City = {
  __typename?: 'City';
  city: Scalars['String']['output'];
  distance: Scalars['Float']['output'];
  distressedAdjustedN?: Maybe<Scalars['Float']['output']>;
  distressedRatioRaw?: Maybe<Scalars['Float']['output']>;
  distressedSalesComponentPercentileNew?: Maybe<Scalars['Float']['output']>;
  distressedSalesCountRaw?: Maybe<Scalars['Int']['output']>;
  flipComponentPercentileNew?: Maybe<Scalars['Float']['output']>;
  flipsN?: Maybe<Scalars['Float']['output']>;
  flipsRaw: Scalars['Int']['output'];
  homeValue: Scalars['Float']['output'];
  housingUnits: Scalars['Int']['output'];
  housingUnitsLogN?: Maybe<Scalars['Float']['output']>;
  keyword1Cpc?: Maybe<Scalars['Float']['output']>;
  keyword1Kd?: Maybe<Scalars['Float']['output']>;
  keyword1Term?: Maybe<Scalars['String']['output']>;
  keyword1Vol?: Maybe<Scalars['Int']['output']>;
  keyword2Cpc?: Maybe<Scalars['Float']['output']>;
  keyword2Kd?: Maybe<Scalars['Float']['output']>;
  keyword2Term?: Maybe<Scalars['String']['output']>;
  keyword2Vol?: Maybe<Scalars['Int']['output']>;
  keyword3Cpc?: Maybe<Scalars['Float']['output']>;
  keyword3Kd?: Maybe<Scalars['Float']['output']>;
  keyword3Term?: Maybe<Scalars['String']['output']>;
  keyword3Vol?: Maybe<Scalars['Int']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  marketDynamicComponentPercentileNew?: Maybe<Scalars['Float']['output']>;
  marketDynamicsN?: Maybe<Scalars['Float']['output']>;
  marketDynamicsPill?: Maybe<Scalars['String']['output']>;
  opportunityScore: Scalars['Float']['output'];
  overallScorePercentileNew?: Maybe<Scalars['Float']['output']>;
  population: Scalars['Int']['output'];
  populationMaturityN?: Maybe<Scalars['Float']['output']>;
  populationMaturityPill?: Maybe<Scalars['String']['output']>;
  rawOpportunityScore?: Maybe<Scalars['Float']['output']>;
  salesN?: Maybe<Scalars['Float']['output']>;
  stateId: Scalars['String']['output'];
  totalSalesRaw: Scalars['Int']['output'];
  trafficAndLeadsComponentPercentileNew?: Maybe<Scalars['Float']['output']>;
  trafficAndLeadsPill?: Maybe<Scalars['String']['output']>;
  trafficLeadsIndex?: Maybe<Scalars['Float']['output']>;
  wholesaleFlipsPill?: Maybe<Scalars['String']['output']>;
};

export type Coupon = {
  __typename?: 'Coupon';
  active?: Maybe<Scalars['Boolean']['output']>;
  amountOff?: Maybe<Scalars['Int']['output']>;
  bundleable?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  durationInMonths?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  maxRedemptions?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentOff?: Maybe<Scalars['Int']['output']>;
  processorId?: Maybe<Scalars['String']['output']>;
  redeemBy?: Maybe<Scalars['ISO8601DateTime']['output']>;
  timesRedeemed?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of CreateAndChargeBundleInvoice */
export type CreateAndChargeBundleInvoiceInput = {
  bundleId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  wordpressUserId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateAndChargeBundleInvoice. */
export type CreateAndChargeBundleInvoicePayload = {
  __typename?: 'CreateAndChargeBundleInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Error>;
  invoice?: Maybe<StripeInvoice>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateAndChargeInvoice */
export type CreateAndChargeInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  couponIds: Array<Scalars['Int']['input']>;
  prices: Array<PriceQuantity>;
  wordpressUserId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateAndChargeInvoice. */
export type CreateAndChargeInvoicePayload = {
  __typename?: 'CreateAndChargeInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<StripeInvoice>;
};

/** Autogenerated input type of CreateAndChargeVideoPostInvoice */
export type CreateAndChargeVideoPostInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  couponIds: Array<Scalars['Int']['input']>;
  seconds: Scalars['Int']['input'];
  wordpressUserId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateAndChargeVideoPostInvoice. */
export type CreateAndChargeVideoPostInvoicePayload = {
  __typename?: 'CreateAndChargeVideoPostInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<StripeInvoice>;
};

/** Autogenerated input type of CreateBundle */
export type CreateBundleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  confirmationUrl?: InputMaybe<Scalars['String']['input']>;
  couponId?: InputMaybe<Scalars['Int']['input']>;
  creationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customerType?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Scalars['String']['input'];
  marketingEvents: Array<BundleMarketingEventInput>;
  marketingLineItems: Array<Scalars['String']['input']>;
  nonCheckoutOneTimeCouponId?: InputMaybe<Scalars['Int']['input']>;
  nonCheckoutRecurringCouponId?: InputMaybe<Scalars['Int']['input']>;
  priceIds: Array<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
  subtitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
  total: Scalars['String']['input'];
};

/** Autogenerated return type of CreateBundle. */
export type CreateBundlePayload = {
  __typename?: 'CreateBundlePayload';
  bundle?: Maybe<Bundle>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateUpcomingInvoice */
export type CreateUpcomingInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  items: Array<PriceQuantity>;
  wordpressUserId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateUpcomingInvoice. */
export type CreateUpcomingInvoicePayload = {
  __typename?: 'CreateUpcomingInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<PaySubscriptionDiscount>;
  errors: Array<UserInputError>;
  removedDiscount?: Maybe<PaySubscriptionDiscount>;
  upcomingInvoice?: Maybe<UpcomingInvoicePreview>;
};

/** Autogenerated input type of DeleteBundle */
export type DeleteBundleInput = {
  bundleId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteBundle. */
export type DeleteBundlePayload = {
  __typename?: 'DeleteBundlePayload';
  bundle?: Maybe<Bundle>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteUser */
export type DeleteUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  wordpressUserId: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteUser. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DomainAuthority = {
  __typename?: 'DomainAuthority';
  authorityScore: Scalars['Int']['output'];
  backlinks: Scalars['BigInt']['output'];
  carrotSite: Scalars['Boolean']['output'];
  domain: Scalars['String']['output'];
  nationalSite: Scalars['Boolean']['output'];
  position?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of DomainAuthorityComparison */
export type DomainAuthorityComparisonInput = {
  city: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  stateId: Scalars['String']['input'];
};

/** Autogenerated return type of DomainAuthorityComparison. */
export type DomainAuthorityComparisonPayload = {
  __typename?: 'DomainAuthorityComparisonPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  domains?: Maybe<Array<DomainAuthority>>;
  errors: Array<Scalars['String']['output']>;
  frictionScore?: Maybe<Scalars['Float']['output']>;
  marketAverage?: Maybe<Scalars['Float']['output']>;
  nationalAverage?: Maybe<Scalars['Float']['output']>;
};

export type Error = {
  __typename?: 'Error';
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ErrorDetail = {
  __typename?: 'ErrorDetail';
  code?: Maybe<Scalars['String']['output']>;
  httpCode?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type FeatureList = {
  __typename?: 'FeatureList';
  agentSiteCount: Scalars['Int']['output'];
  campaignLinkCount: Scalars['Int']['output'];
  contentTools: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  crmSeatCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  integrations: Scalars['Boolean']['output'];
  investorSiteCount: Scalars['Int']['output'];
  keywordCount: Scalars['Int']['output'];
  premiumTemplate: Scalars['Boolean']['output'];
  price: Price;
  priceId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type FeatureListPriceArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  actives?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  amounts?: InputMaybe<Array<Scalars['Int']['input']>>;
  billingScheme?: InputMaybe<Scalars['String']['input']>;
  billingSchemes?: InputMaybe<Array<Scalars['String']['input']>>;
  bundleable?: InputMaybe<Scalars['Boolean']['input']>;
  bundleables?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAts?: InputMaybe<Array<Scalars['ISO8601DateTime']['input']>>;
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customerType?: InputMaybe<Scalars['String']['input']>;
  customerTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  interval?: InputMaybe<Scalars['String']['input']>;
  intervals?: InputMaybe<Array<Scalars['String']['input']>>;
  listTitle?: InputMaybe<Scalars['String']['input']>;
  listTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  lookupKey?: InputMaybe<Scalars['String']['input']>;
  lookupKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  marketingList?: InputMaybe<Scalars['String']['input']>;
  marketingLists?: InputMaybe<Array<Scalars['String']['input']>>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  nicknames?: InputMaybe<Array<Scalars['String']['input']>>;
  priceType?: InputMaybe<Scalars['String']['input']>;
  priceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  stripeId?: InputMaybe<Scalars['String']['input']>;
  stripeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  subtitles?: InputMaybe<Array<Scalars['String']['input']>>;
  taxBehavior?: InputMaybe<Scalars['String']['input']>;
  taxBehaviors?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAts?: InputMaybe<Array<Scalars['ISO8601DateTime']['input']>>;
  version?: InputMaybe<Scalars['Int']['input']>;
  versions?: InputMaybe<Array<Scalars['Int']['input']>>;
  wordpressLabel?: InputMaybe<Scalars['String']['input']>;
  wordpressLabels?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GoogleAuthConfig = {
  __typename?: 'GoogleAuthConfig';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId: Scalars['Int']['output'];
};

/** Autogenerated input type of HideSiteAuditReportIssueDetail */
export type HideSiteAuditReportIssueDetailInput = {
  auditSnapshotId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Int']['input'];
  issueId: Scalars['Int']['input'];
};

/** Autogenerated return type of HideSiteAuditReportIssueDetail. */
export type HideSiteAuditReportIssueDetailPayload = {
  __typename?: 'HideSiteAuditReportIssueDetailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of HideSiteAuditReportIssue */
export type HideSiteAuditReportIssueInput = {
  auditSnapshotId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  issueId: Scalars['Int']['input'];
};

/** Autogenerated return type of HideSiteAuditReportIssue. */
export type HideSiteAuditReportIssuePayload = {
  __typename?: 'HideSiteAuditReportIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of InitiateAudit */
export type InitiateAuditInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  wordpressBlogId: Scalars['Int']['input'];
};

/** Autogenerated return type of InitiateAudit. */
export type InitiateAuditPayload = {
  __typename?: 'InitiateAuditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type KeywordOverviews = {
  __typename?: 'KeywordOverviews';
  difficulty?: Maybe<Scalars['Int']['output']>;
  phrase: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  traffic?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  volume: Scalars['Int']['output'];
};

export type KeywordReport = {
  __typename?: 'KeywordReport';
  hasMoreResults?: Maybe<Scalars['Boolean']['output']>;
  keywordOverviews?: Maybe<Array<KeywordOverviews>>;
  orderBy?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  phraseSearchType?: Maybe<Scalars['String']['output']>;
  reportType: Report;
  searchTerm: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['String']['output']>;
};

export type LandingPageReport = {
  __typename?: 'LandingPageReport';
  avgEngagementTimePerSession?: Maybe<Scalars['Float']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  conversions: Scalars['Int']['output'];
  landingPage: Scalars['String']['output'];
  pageViewsPerVisitor?: Maybe<Scalars['Float']['output']>;
  visitors: Scalars['Int']['output'];
};

/** Autogenerated input type of MarketReport */
export type MarketReportInput = {
  city: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  count: Scalars['Int']['input'];
  radius: Scalars['Int']['input'];
  stateId: Scalars['String']['input'];
};

/** Autogenerated return type of MarketReport. */
export type MarketReportPayload = {
  __typename?: 'MarketReportPayload';
  adjacentCities?: Maybe<Array<City>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  targetCity?: Maybe<City>;
};

export type MarketScoutCity = {
  city: Scalars['String']['input'];
  distance: Scalars['Float']['input'];
  distressedAdjustedN?: InputMaybe<Scalars['Float']['input']>;
  distressedRatioRaw?: InputMaybe<Scalars['Float']['input']>;
  distressedSalesComponentPercentileNew?: InputMaybe<Scalars['Float']['input']>;
  distressedSalesCountRaw?: InputMaybe<Scalars['Int']['input']>;
  flipComponentPercentileNew?: InputMaybe<Scalars['Float']['input']>;
  flipsN?: InputMaybe<Scalars['Float']['input']>;
  flipsRaw: Scalars['Int']['input'];
  homeValue: Scalars['Int']['input'];
  housingUnits: Scalars['Int']['input'];
  housingUnitsLogN?: InputMaybe<Scalars['Float']['input']>;
  keyword1Cpc?: InputMaybe<Scalars['Float']['input']>;
  keyword1Kd?: InputMaybe<Scalars['Float']['input']>;
  keyword1Term?: InputMaybe<Scalars['String']['input']>;
  keyword1Vol?: InputMaybe<Scalars['Int']['input']>;
  keyword2Cpc?: InputMaybe<Scalars['Float']['input']>;
  keyword2Kd?: InputMaybe<Scalars['Float']['input']>;
  keyword2Term?: InputMaybe<Scalars['String']['input']>;
  keyword2Vol?: InputMaybe<Scalars['Int']['input']>;
  keyword3Cpc?: InputMaybe<Scalars['Float']['input']>;
  keyword3Kd?: InputMaybe<Scalars['Float']['input']>;
  keyword3Term?: InputMaybe<Scalars['String']['input']>;
  keyword3Vol?: InputMaybe<Scalars['Int']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  marketDynamicComponentPercentileNew?: InputMaybe<Scalars['Float']['input']>;
  marketDynamicsN?: InputMaybe<Scalars['Float']['input']>;
  marketDynamicsPill?: InputMaybe<Scalars['String']['input']>;
  opportunityScore?: InputMaybe<Scalars['Float']['input']>;
  overallScorePercentileNew?: InputMaybe<Scalars['Float']['input']>;
  population: Scalars['Int']['input'];
  populationMaturityN?: InputMaybe<Scalars['Float']['input']>;
  populationMaturityPill?: InputMaybe<Scalars['String']['input']>;
  rawOpportunityScore?: InputMaybe<Scalars['Float']['input']>;
  salesN?: InputMaybe<Scalars['Float']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
  totalSalesRaw: Scalars['Int']['input'];
  trafficAndLeadsComponentPercentileNew?: InputMaybe<Scalars['Float']['input']>;
  trafficAndLeadsPill?: InputMaybe<Scalars['String']['input']>;
  trafficLeadsIndex?: InputMaybe<Scalars['Float']['input']>;
  wholesaleFlipsPill?: InputMaybe<Scalars['String']['input']>;
};

export type MarketScoutStrategy = {
  __typename?: 'MarketScoutStrategy';
  city?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['String']['output']>;
  stateId?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type MembershipBuilderSelection = {
  __typename?: 'MembershipBuilderSelection';
  price: Price;
  quantity: Scalars['Int']['output'];
  selected: Scalars['Boolean']['output'];
};

export type MembershipEditor = {
  __typename?: 'MembershipEditor';
  annualPrice: Price;
  availabilityErrors: Array<Scalars['String']['output']>;
  available: Scalars['Boolean']['output'];
  interval: Scalars['String']['output'];
  maximum?: Maybe<Scalars['Int']['output']>;
  minimum?: Maybe<Scalars['Int']['output']>;
  minimumErrors: Array<Scalars['String']['output']>;
  monthlyPrice: Price;
  product: Product;
  quantity: Scalars['Int']['output'];
  selected: Scalars['Boolean']['output'];
};

export type MembershipManagement = {
  __typename?: 'MembershipManagement';
  balance?: Maybe<Scalars['Int']['output']>;
  cancellationRequestLink?: Maybe<Scalars['String']['output']>;
  customerPortalUrl?: Maybe<Scalars['String']['output']>;
  payPaymentMethod?: Maybe<PayPaymentMethod>;
  paySubscription?: Maybe<PaySubscription>;
};

/** Autogenerated input type of MigrateCustomerStripe */
export type MigrateCustomerStripeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['ISO8601DateTime']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  keapId?: InputMaybe<Scalars['Int']['input']>;
  lastName: Scalars['String']['input'];
  superAdmin: Scalars['Boolean']['input'];
  wordpressUserId: Scalars['Int']['input'];
  wordpressUsername: Scalars['String']['input'];
};

/** Autogenerated return type of MigrateCustomerStripe. */
export type MigrateCustomerStripePayload = {
  __typename?: 'MigrateCustomerStripePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activeAccountUpdate?: Maybe<ActiveAccountUpdatePayload>;
  addEmailToAnonymousUser?: Maybe<AddEmailToAnonymousUserPayload>;
  addPriceToSubscription?: Maybe<AddPriceToSubscriptionPayload>;
  /** Create a new blocked phone number for an account. */
  blockedNumberCreate?: Maybe<BlockedNumberCreatePayload>;
  /** Destroy a blocked phone number for an account. */
  blockedNumberDestroy?: Maybe<BlockedNumberDestroyPayload>;
  buyPhoneNumber?: Maybe<PhoneNumberBuyPayload>;
  campaignChildrenEdit?: Maybe<CampaignChildrenEditPayload>;
  campaignEdit?: Maybe<CampaignEditPayload>;
  cancelSubscriptionAtPeriodEnd?: Maybe<CancelSubscriptionAtPeriodEndPayload>;
  carrotCrmOptInUser?: Maybe<CarrotCrmOptInUserPayload>;
  createAccount?: Maybe<AccountCreationPayload>;
  createAndChargeBundleInvoice?: Maybe<CreateAndChargeBundleInvoicePayload>;
  createAndChargeInvoice?: Maybe<CreateAndChargeInvoicePayload>;
  createAndChargeVideoPostInvoice?: Maybe<CreateAndChargeVideoPostInvoicePayload>;
  createBundle?: Maybe<CreateBundlePayload>;
  createUpcomingInvoice?: Maybe<CreateUpcomingInvoicePayload>;
  deleteBundle?: Maybe<DeleteBundlePayload>;
  deleteUser?: Maybe<DeleteUserPayload>;
  domainAuthorityComparison?: Maybe<DomainAuthorityComparisonPayload>;
  hideSiteAuditReportIssue?: Maybe<HideSiteAuditReportIssuePayload>;
  hideSiteAuditReportIssueDetail?: Maybe<HideSiteAuditReportIssueDetailPayload>;
  initiateAudit?: Maybe<InitiateAuditPayload>;
  marketReport?: Maybe<MarketReportPayload>;
  migrateCustomerStripe?: Maybe<MigrateCustomerStripePayload>;
  onboardingUpdate?: Maybe<OnboardingUpdatePayload>;
  phoneNumberDestroy?: Maybe<PhoneNumberDestroyPayload>;
  /** Edit an existing phone number for call tracking. */
  phoneNumberEdit?: Maybe<PhoneNumberEditPayload>;
  queueWpCallbackJob?: Maybe<QueueWpCallbackJobPayload>;
  stripeBundleCheckout?: Maybe<StripeBundleCheckoutPayload>;
  stripeCustomerPortal?: Maybe<StripeCustomerPortalPayload>;
  stripeSubscriptionCheckout?: Maybe<StripeSubscriptionCheckoutPayload>;
  syncWordpressMetadata?: Maybe<SyncWordpressMetadataPayload>;
  teamMemberAcceptInvite?: Maybe<TeamMemberAcceptInvitePayload>;
  teamMemberAddToAccount?: Maybe<TeamMemberAddToAccountPayload>;
  teamMemberBlogRoleUpdate?: Maybe<TeamMemberBlogRoleUpdatePayload>;
  teamMemberDelete?: Maybe<TeamMemberDeletePayload>;
  teamMemberEdit?: Maybe<TeamMemberEditPayload>;
  trackSignup?: Maybe<TrackSignupPayload>;
  /** Create a new Twilio subaccount for the given account. */
  twilioSubaccountCreate?: Maybe<TwilioSubaccountCreatePayload>;
  unhideAllSiteAuditReportIssueDetails?: Maybe<UnhideAllSiteAuditReportIssueDetailsPayload>;
  unhideAllSiteAuditReportIssues?: Maybe<UnhideAllSiteAuditReportIssuesPayload>;
  updateSubscription?: Maybe<UpdateSubscriptionPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  upgradeContentProToStandard?: Maybe<UpgradeContentProToStandardPayload>;
  wpBlogCreate?: Maybe<WpBlogCreatePayload>;
  wpBlogEdit?: Maybe<WpBlogEditPayload>;
  wpBlogUpdate?: Maybe<WpBlogUpdatePayload>;
  wpBlogUpdateMappedDomain?: Maybe<WpBlogUpdateMappedDomainPayload>;
};


export type MutationActiveAccountUpdateArgs = {
  input: ActiveAccountUpdateInput;
};


export type MutationAddEmailToAnonymousUserArgs = {
  input: AddEmailToAnonymousUserInput;
};


export type MutationAddPriceToSubscriptionArgs = {
  input: AddPriceToSubscriptionInput;
};


export type MutationBlockedNumberCreateArgs = {
  input: BlockedNumberCreateInput;
};


export type MutationBlockedNumberDestroyArgs = {
  input: BlockedNumberDestroyInput;
};


export type MutationBuyPhoneNumberArgs = {
  input: PhoneNumberBuyInput;
};


export type MutationCampaignChildrenEditArgs = {
  input: CampaignChildrenEditInput;
};


export type MutationCampaignEditArgs = {
  input: CampaignEditInput;
};


export type MutationCancelSubscriptionAtPeriodEndArgs = {
  input: CancelSubscriptionAtPeriodEndInput;
};


export type MutationCarrotCrmOptInUserArgs = {
  input: CarrotCrmOptInUserInput;
};


export type MutationCreateAccountArgs = {
  input: AccountCreationInput;
};


export type MutationCreateAndChargeBundleInvoiceArgs = {
  input: CreateAndChargeBundleInvoiceInput;
};


export type MutationCreateAndChargeInvoiceArgs = {
  input: CreateAndChargeInvoiceInput;
};


export type MutationCreateAndChargeVideoPostInvoiceArgs = {
  input: CreateAndChargeVideoPostInvoiceInput;
};


export type MutationCreateBundleArgs = {
  input: CreateBundleInput;
};


export type MutationCreateUpcomingInvoiceArgs = {
  input: CreateUpcomingInvoiceInput;
};


export type MutationDeleteBundleArgs = {
  input: DeleteBundleInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDomainAuthorityComparisonArgs = {
  input: DomainAuthorityComparisonInput;
};


export type MutationHideSiteAuditReportIssueArgs = {
  input: HideSiteAuditReportIssueInput;
};


export type MutationHideSiteAuditReportIssueDetailArgs = {
  input: HideSiteAuditReportIssueDetailInput;
};


export type MutationInitiateAuditArgs = {
  input: InitiateAuditInput;
};


export type MutationMarketReportArgs = {
  input: MarketReportInput;
};


export type MutationMigrateCustomerStripeArgs = {
  input: MigrateCustomerStripeInput;
};


export type MutationOnboardingUpdateArgs = {
  input: OnboardingUpdateInput;
};


export type MutationPhoneNumberDestroyArgs = {
  input: PhoneNumberDestroyInput;
};


export type MutationPhoneNumberEditArgs = {
  input: PhoneNumberEditInput;
};


export type MutationQueueWpCallbackJobArgs = {
  input: QueueWpCallbackJobInput;
};


export type MutationStripeBundleCheckoutArgs = {
  input: StripeBundleCheckoutInput;
};


export type MutationStripeCustomerPortalArgs = {
  input: StripeCustomerPortalInput;
};


export type MutationStripeSubscriptionCheckoutArgs = {
  input: StripeSubscriptionCheckoutInput;
};


export type MutationSyncWordpressMetadataArgs = {
  input: SyncWordpressMetadataInput;
};


export type MutationTeamMemberAcceptInviteArgs = {
  input: TeamMemberAcceptInviteInput;
};


export type MutationTeamMemberAddToAccountArgs = {
  input: TeamMemberAddToAccountInput;
};


export type MutationTeamMemberBlogRoleUpdateArgs = {
  input: TeamMemberBlogRoleUpdateInput;
};


export type MutationTeamMemberDeleteArgs = {
  input: TeamMemberDeleteInput;
};


export type MutationTeamMemberEditArgs = {
  input: TeamMemberEditInput;
};


export type MutationTrackSignupArgs = {
  input: TrackSignupInput;
};


export type MutationTwilioSubaccountCreateArgs = {
  input: TwilioSubaccountCreateInput;
};


export type MutationUnhideAllSiteAuditReportIssueDetailsArgs = {
  input: UnhideAllSiteAuditReportIssueDetailsInput;
};


export type MutationUnhideAllSiteAuditReportIssuesArgs = {
  input: UnhideAllSiteAuditReportIssuesInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpgradeContentProToStandardArgs = {
  input: UpgradeContentProToStandardInput;
};


export type MutationWpBlogCreateArgs = {
  input: WpBlogCreateInput;
};


export type MutationWpBlogEditArgs = {
  input: WpBlogEditInput;
};


export type MutationWpBlogUpdateArgs = {
  input: WpBlogUpdateInput;
};


export type MutationWpBlogUpdateMappedDomainArgs = {
  input: WpBlogUpdateMappedDomainInput;
};

export type Onboarding = {
  __typename?: 'Onboarding';
  collaboration?: Maybe<Scalars['String']['output']>;
  collaborations: Array<Scalars['String']['output']>;
  companyAddress?: Maybe<Scalars['String']['output']>;
  companyCity?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPhone?: Maybe<Scalars['String']['output']>;
  companyState?: Maybe<Scalars['String']['output']>;
  companyZip?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  experience?: Maybe<Scalars['String']['output']>;
  experiences: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  marketCity?: Maybe<Scalars['String']['output']>;
  marketState?: Maybe<Scalars['String']['output']>;
  marketZip?: Maybe<Scalars['String']['output']>;
  primaryIndustries: Array<Scalars['String']['output']>;
  primaryIndustry?: Maybe<Scalars['String']['output']>;
  primaryIndustryFocus?: Maybe<Scalars['String']['output']>;
  primaryIndustryFocuses: Scalars['JSON']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  referenceDetails?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

/** Autogenerated input type of OnboardingUpdate */
export type OnboardingUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  collaboration?: InputMaybe<Scalars['String']['input']>;
  companyAddress?: InputMaybe<Scalars['String']['input']>;
  companyCity?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyPhone?: InputMaybe<Scalars['String']['input']>;
  companyState?: InputMaybe<Scalars['String']['input']>;
  companyZip?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Scalars['String']['input']>;
  primaryIndustry?: InputMaybe<Scalars['String']['input']>;
  primaryIndustryFocus?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  referenceDetails?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of OnboardingUpdate. */
export type OnboardingUpdatePayload = {
  __typename?: 'OnboardingUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  success: Scalars['Boolean']['output'];
};

export type OrganicOverviewReport = {
  __typename?: 'OrganicOverviewReport';
  domainOverviewHistories?: Maybe<Array<WpBlogDomainOverviewHistory>>;
  organicVisitors?: Maybe<Array<TrafficAndLeadsDataPoints>>;
};

export type OrganicProfileReport = {
  __typename?: 'OrganicProfileReport';
  keywords: Scalars['Int']['output'];
  keywordsChange?: Maybe<Scalars['Float']['output']>;
  organicVisitors: Scalars['Int']['output'];
  organicVisitorsChange?: Maybe<Scalars['Float']['output']>;
};

export type PayCharge = {
  __typename?: 'PayCharge';
  amount: Scalars['Int']['output'];
  amountRefunded?: Maybe<Scalars['Int']['output']>;
  applicationFeeAmount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['Int']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<StripeInvoiceLineItem>>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  processorId: Scalars['String']['output'];
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  tax: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PayPaymentMethod = {
  __typename?: 'PayPaymentMethod';
  billingDetails?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerId: Scalars['Int']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  processorId: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PaySubscription = {
  __typename?: 'PaySubscription';
  addOns: Array<Price>;
  annualLegacyCouponAmount?: Maybe<Scalars['Int']['output']>;
  annualLegacyPrice?: Maybe<Scalars['Int']['output']>;
  applicationFeePercent?: Maybe<Scalars['Float']['output']>;
  cancelAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentPeriodEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customerId: Scalars['Int']['output'];
  discount?: Maybe<PaySubscriptionDiscount>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  items: Array<PaySubscriptionItem>;
  latestInvoices: Array<StripeInvoice>;
  limits: Scalars['JSON']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  monthlyLegacyCouponAmount?: Maybe<Scalars['Int']['output']>;
  monthlyLegacyPrice?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  pastDueCancelAtDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  pastDueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  pendingCancellation: Scalars['Boolean']['output'];
  pendingUpdate: Scalars['Boolean']['output'];
  processorId: Scalars['String']['output'];
  processorPlan: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  requestedCancelAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  starter: Price;
  status: Scalars['String']['output'];
  trialEndsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  usage: Scalars['JSON']['output'];
};

export type PaySubscriptionDiscount = {
  __typename?: 'PaySubscriptionDiscount';
  coupon: Coupon;
  endDate?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  startDate: Scalars['Int']['output'];
};

export type PaySubscriptionItem = {
  __typename?: 'PaySubscriptionItem';
  paySubscriptionId: Scalars['Int']['output'];
  price: Price;
  priceId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  stripeId: Scalars['String']['output'];
};

/** Autogenerated input type of PhoneNumberBuy */
export type PhoneNumberBuyInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

/** Autogenerated return type of PhoneNumberBuy. */
export type PhoneNumberBuyPayload = {
  __typename?: 'PhoneNumberBuyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  phoneNumber?: Maybe<TwilioNumber>;
};

/** Autogenerated input type of PhoneNumberDestroy */
export type PhoneNumberDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumberId: Scalars['Int']['input'];
};

/** Autogenerated return type of PhoneNumberDestroy. */
export type PhoneNumberDestroyPayload = {
  __typename?: 'PhoneNumberDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of PhoneNumberEdit */
export type PhoneNumberEditInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  forwardToNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberId: Scalars['Int']['input'];
};

/** Autogenerated return type of PhoneNumberEdit. */
export type PhoneNumberEditPayload = {
  __typename?: 'PhoneNumberEditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  phoneNumber?: Maybe<TwilioNumber>;
};

export type Price = {
  __typename?: 'Price';
  active: Scalars['Boolean']['output'];
  amount: Scalars['Int']['output'];
  annualSavings: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerType?: Maybe<Scalars['String']['output']>;
  featureList?: Maybe<FeatureList>;
  id: Scalars['Int']['output'];
  interval?: Maybe<Scalars['String']['output']>;
  listTitle?: Maybe<Scalars['String']['output']>;
  lookupKey?: Maybe<Scalars['String']['output']>;
  marketingList?: Maybe<Array<Scalars['String']['output']>>;
  monthlyPrice: Scalars['Int']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  product: Product;
  productId: Scalars['Int']['output'];
  stripeId?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  version?: Maybe<Scalars['Int']['output']>;
  wordpressLabel?: Maybe<Scalars['String']['output']>;
};

export type PriceQuantity = {
  priceId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type Product = {
  __typename?: 'Product';
  active?: Maybe<Scalars['Boolean']['output']>;
  canBundle: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  membershipEditor?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  prices: Array<Price>;
  starter?: Maybe<Scalars['Boolean']['output']>;
  stripeId?: Maybe<Scalars['String']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type ProductPricesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  customerType?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type Query = {
  __typename?: 'Query';
  /** A description of a User's Ability */
  ability?: Maybe<Array<Ability>>;
  /** An Account that the User can access */
  account: Account;
  /** A list of Accounts that the User can access */
  accounts: Array<Account>;
  /** Retrieves an AnonymousUser */
  anonymousUser?: Maybe<AnonymousUser>;
  availablePhoneNumbers?: Maybe<Array<TwilioApiPhoneNumber>>;
  /** Returns the backlink category report data */
  backlinkCategoryReport?: Maybe<WpBlogBacklinkOverview>;
  /** Returns the backlink profile report data */
  backlinkOverviewReport: Array<WpBlogBacklinkOverview>;
  /** Returns the backlink profile report data */
  backlinkProfileReport: BacklinkProfileReport;
  /** Returns the backlink report data */
  backlinkReport: Array<WpBlogBacklink>;
  /** A Bundle */
  bundle?: Maybe<Bundle>;
  /** A list of Bundles */
  bundles: Array<Bundle>;
  /** A Twilio Number */
  callTrackingNumber?: Maybe<TwilioNumber>;
  /** A list of Twilio Numbers */
  callTrackingNumbers?: Maybe<Array<TwilioNumber>>;
  /** A list of CarrotCrmConfigs that the User can access */
  carrotCrmConfigs: Array<CarrotCrmConfig>;
  /** Returns the competitor backlink profile report data */
  competitorBacklinkOverviewReport: BacklinkOverviewReport;
  /** Returns the competitor backlink report data */
  competitorBacklinkReport: BacklinkReport;
  /** A list of Coupons */
  coupons: Array<Coupon>;
  /** Backfills historical data if it is missing. */
  domainOverviewBackfill?: Maybe<Scalars['Boolean']['output']>;
  /** Returns a Keyword Report */
  keywordReport?: Maybe<KeywordReport>;
  /** Returns the landing page report data */
  landingPageReport: Array<LandingPageReport>;
  /** Returns the latest Pay Charge */
  latestInvoice?: Maybe<PayCharge>;
  /** Returns a the options with which to build a Membership */
  membershipBuilderSelection?: Maybe<Array<MembershipBuilderSelection>>;
  /** Returns the options with which to edit a Membership */
  membershipEditor?: Maybe<Array<MembershipEditor>>;
  /** Returns a information to manage a membership */
  membershipManagement?: Maybe<MembershipManagement>;
  /** A Users Onboarding information */
  onboarding: Onboarding;
  /** Returns the organic profile report data */
  organicOverviewReport: OrganicOverviewReport;
  /** Returns the organic profile report data */
  organicProfileReport?: Maybe<OrganicProfileReport>;
  /** A Price */
  price?: Maybe<Price>;
  /** A list of Prices */
  prices: Array<Price>;
  /** A Product */
  product?: Maybe<Product>;
  /** A list of Products */
  products: Array<Product>;
  /** Returns Google Oauth consent URL for enabling Search Performance feature */
  searchPerformanceConsentUrl?: Maybe<SearchPerformanceConsentUrl>;
  /** Returns search performance data to populate the front end */
  searchPerformanceHistory?: Maybe<SearchPerformanceHistory>;
  /** Returns search performance data to populate the front end */
  searchPerformancePageUrl?: Maybe<SearchPerformancePageUrl>;
  /** Returns search performance data to populate the front end */
  searchPerformanceQueryString?: Maybe<SearchPerformanceQueryString>;
  /** SiteAuditReportType */
  siteAuditReport?: Maybe<SiteAuditReport>;
  /** SiteAuditReportIssueDetailsType */
  siteAuditReportIssueDetails?: Maybe<AuditSnapshot>;
  /** Returns the total visitors for multiple sites */
  siteDashboardVisitor: SiteDashboardVisitor;
  strategyRecommendations?: Maybe<Array<MarketScoutStrategy>>;
  /** Returns an array of PaySubscriptions that include a Product. */
  subscriptionsByProduct: Array<PaySubscription>;
  teamMemberAbility?: Maybe<Array<Ability>>;
  /** Returns a list of valid roles for a Team Member Account */
  teamMemberAccountRoles?: Maybe<Array<Scalars['String']['output']>>;
  /** Returns the top pages report data */
  topPagesReport: Array<TopPagesReport>;
  /** Returns the landing page report data */
  trafficAndLeadsReport: TrafficAndLeadsReport;
  /** Returns the landing page report data */
  trafficSourceReport: Array<TrafficSourceReport>;
  /** A User */
  user?: Maybe<User>;
  /** A list of Users */
  users: Array<User>;
  /** Returns a list of valid roles for a Team Member Blog Role */
  validTeamMemberBlogRoles: Array<Scalars['String']['output']>;
  /** Returns a list of Wordpress User Meta */
  wordpressUserMeta?: Maybe<WordpressUserMeta>;
  /** A WpBlog */
  wpBlog?: Maybe<WpBlog>;
  /** Returns the WpBlog backlink upsell report data */
  wpBlogBacklinkUpsellReport?: Maybe<WpBlogBacklinkUpsell>;
  /** A WpBlog */
  wpBlogs: Array<WpBlog>;
};


export type QueryAbilityArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAccountArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryAnonymousUserArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAvailablePhoneNumbersArgs = {
  accountId: Scalars['Int']['input'];
  areaCode: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBacklinkCategoryReportArgs = {
  wordpressBlogId: Scalars['Int']['input'];
};


export type QueryBacklinkOverviewReportArgs = {
  weeksAgo?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId: Scalars['Int']['input'];
};


export type QueryBacklinkProfileReportArgs = {
  weeksAgo?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId: Scalars['Int']['input'];
};


export type QueryBacklinkReportArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  wordpressBlogId: Scalars['Int']['input'];
};


export type QueryBundleArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBundlesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryCallTrackingNumberArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCallTrackingNumbersArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryCompetitorBacklinkOverviewReportArgs = {
  domain: Scalars['String']['input'];
};


export type QueryCompetitorBacklinkReportArgs = {
  domain: Scalars['String']['input'];
  pageNumber: Scalars['Int']['input'];
};


export type QueryCouponsArgs = {
  bundleable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDomainOverviewBackfillArgs = {
  wordpressBlogId: Scalars['Int']['input'];
};


export type QueryKeywordReportArgs = {
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  phraseSearchType?: InputMaybe<Scalars['String']['input']>;
  reportType: Report;
  searchTerm: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLandingPageReportArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId: Scalars['Int']['input'];
};


export type QueryMembershipBuilderSelectionArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  selectedPrices?: InputMaybe<Array<PriceQuantity>>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMembershipEditorArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMembershipManagementArgs = {
  wordpressUserId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganicOverviewReportArgs = {
  weeksAgo?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId: Scalars['Int']['input'];
};


export type QueryOrganicProfileReportArgs = {
  weeksAgo?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId: Scalars['Int']['input'];
};


export type QueryPriceArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bundleable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lookupKey?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  processorId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPricesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bundleable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  lookupKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  nicknames?: InputMaybe<Array<Scalars['String']['input']>>;
  processorId?: InputMaybe<Scalars['String']['input']>;
  processorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  version?: InputMaybe<Scalars['Int']['input']>;
  versions?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryProductArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  processorId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchPerformanceConsentUrlArgs = {
  wordpressBlogId: Scalars['Int']['input'];
};


export type QuerySearchPerformanceHistoryArgs = {
  days: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  pageUrlFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  queryStringFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  wordpressBlogId: Scalars['Int']['input'];
};


export type QuerySearchPerformancePageUrlArgs = {
  days: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  pageUrlFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  queryStringFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  wordpressBlogId: Scalars['Int']['input'];
};


export type QuerySearchPerformanceQueryStringArgs = {
  days: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  pageUrlFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  queryStringFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  wordpressBlogId: Scalars['Int']['input'];
};


export type QuerySiteAuditReportArgs = {
  wordpressBlogId: Scalars['Int']['input'];
};


export type QuerySiteAuditReportIssueDetailsArgs = {
  auditSnapshotId: Scalars['Int']['input'];
  issueId: Scalars['Int']['input'];
};


export type QuerySiteDashboardVisitorArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStrategyRecommendationsArgs = {
  cities: Array<MarketScoutCity>;
};


export type QuerySubscriptionsByProductArgs = {
  productName: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTeamMemberAbilityArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
  wordpressUserId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTopPagesReportArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId: Scalars['Int']['input'];
};


export type QueryTrafficAndLeadsReportArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId: Scalars['Int']['input'];
};


export type QueryTrafficSourceReportArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId: Scalars['Int']['input'];
};


export type QueryUserArgs = {
  wordpressUserId: Scalars['Int']['input'];
};


export type QueryUsersArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  wordpressUserId?: InputMaybe<Scalars['Int']['input']>;
  wordpressUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryWordpressUserMetaArgs = {
  meta: Array<Scalars['String']['input']>;
};


export type QueryWpBlogArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  mappedDomain?: InputMaybe<Scalars['String']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWpBlogBacklinkUpsellReportArgs = {
  wordpressBlogId: Scalars['Int']['input'];
};


export type QueryWpBlogsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  mappedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Autogenerated input type of QueueWpCallbackJob */
export type QueueWpCallbackJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  serializedJobData: Scalars['String']['input'];
};

/** Autogenerated return type of QueueWpCallbackJob. */
export type QueueWpCallbackJobPayload = {
  __typename?: 'QueueWpCallbackJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum Report {
  Domain = 'DOMAIN',
  Phrase = 'PHRASE'
}

export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId: Scalars['Int']['output'];
  wpBlogId: Scalars['Int']['output'];
};

export type SearchPerformanceConsentUrl = {
  __typename?: 'SearchPerformanceConsentUrl';
  consentUrl?: Maybe<Scalars['String']['output']>;
  error?: Maybe<ErrorDetail>;
};

export type SearchPerformanceHistory = {
  __typename?: 'SearchPerformanceHistory';
  data?: Maybe<Array<SearchPerformanceHistoryInstance>>;
  error?: Maybe<ErrorDetail>;
};

export type SearchPerformanceHistoryInstance = {
  __typename?: 'SearchPerformanceHistoryInstance';
  clicks: Scalars['Float']['output'];
  ctr: Scalars['Float']['output'];
  date: Scalars['ISO8601Date']['output'];
  impressions: Scalars['Float']['output'];
  position: Scalars['Float']['output'];
};

export type SearchPerformancePageUrl = {
  __typename?: 'SearchPerformancePageUrl';
  data?: Maybe<Array<SearchPerformancePageUrlInstance>>;
  error?: Maybe<ErrorDetail>;
};

export type SearchPerformancePageUrlInstance = {
  __typename?: 'SearchPerformancePageUrlInstance';
  clicks: Scalars['Float']['output'];
  ctr: Scalars['Float']['output'];
  impressions: Scalars['Float']['output'];
  pageUrl: Scalars['String']['output'];
  position: Scalars['Float']['output'];
};

export type SearchPerformanceQueryString = {
  __typename?: 'SearchPerformanceQueryString';
  data?: Maybe<Array<SearchPerformanceQueryStringInstance>>;
  error?: Maybe<ErrorDetail>;
};

export type SearchPerformanceQueryStringInstance = {
  __typename?: 'SearchPerformanceQueryStringInstance';
  clicks: Scalars['Float']['output'];
  ctr: Scalars['Float']['output'];
  impressions: Scalars['Float']['output'];
  position: Scalars['Float']['output'];
  queryString: Scalars['String']['output'];
};

export type SiteAuditReport = {
  __typename?: 'SiteAuditReport';
  auditCampaign?: Maybe<AuditCampaign>;
  auditSnapshot?: Maybe<AuditSnapshot>;
  auditSnapshots?: Maybe<Array<AuditSnapshot>>;
  error?: Maybe<Scalars['String']['output']>;
};

export type SiteDashboardVisitor = {
  __typename?: 'SiteDashboardVisitor';
  visitorTotalPerSite: Array<TotalVisitorsPerSite>;
};

/** Autogenerated input type of StripeBundleCheckout */
export type StripeBundleCheckoutInput = {
  bundleId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of StripeBundleCheckout. */
export type StripeBundleCheckoutPayload = {
  __typename?: 'StripeBundleCheckoutPayload';
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of StripeCustomerPortal */
export type StripeCustomerPortalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  wordpressUserId: Scalars['Int']['input'];
};

/** Autogenerated return type of StripeCustomerPortal. */
export type StripeCustomerPortalPayload = {
  __typename?: 'StripeCustomerPortalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StripeInvoice = {
  __typename?: 'StripeInvoice';
  amountDue?: Maybe<Scalars['Int']['output']>;
  amountPaid?: Maybe<Scalars['Int']['output']>;
  amountRemaining?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lines?: Maybe<Scalars['JSON']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  periodEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  periodStart?: Maybe<Scalars['ISO8601DateTime']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type StripeInvoiceLineItem = {
  __typename?: 'StripeInvoiceLineItem';
  amount: Scalars['Int']['output'];
  amountExcludingTax: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  price: Price;
  quantity: Scalars['Int']['output'];
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  id: Scalars['String']['output'];
  invoices: Array<StripeInvoice>;
  lineItems: Array<StripeSubscriptionLineItem>;
};

/** Autogenerated input type of StripeSubscriptionCheckout */
export type StripeSubscriptionCheckoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<StripeSubscriptionLineItemInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  trial?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of StripeSubscriptionCheckout. */
export type StripeSubscriptionCheckoutPayload = {
  __typename?: 'StripeSubscriptionCheckoutPayload';
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type StripeSubscriptionLineItem = {
  __typename?: 'StripeSubscriptionLineItem';
  price?: Maybe<Price>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type StripeSubscriptionLineItemInput = {
  priceId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

/** Autogenerated input type of SyncWordpressMetadata */
export type SyncWordpressMetadataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of SyncWordpressMetadata. */
export type SyncWordpressMetadataPayload = {
  __typename?: 'SyncWordpressMetadataPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  success?: Maybe<Scalars['JSON']['output']>;
};

export type TeamMember = {
  __typename?: 'TeamMember';
  account?: Maybe<Account>;
  accountRole: Scalars['String']['output'];
  blogRoles: Array<TeamMemberBlogRole>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  crmSeat: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  inviteEmail: Scalars['String']['output'];
  pending: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  uuid: Scalars['String']['output'];
};

/** Autogenerated input type of TeamMemberAcceptInvite */
export type TeamMemberAcceptInviteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

/** Autogenerated return type of TeamMemberAcceptInvite. */
export type TeamMemberAcceptInvitePayload = {
  __typename?: 'TeamMemberAcceptInvitePayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of TeamMemberAddToAccount */
export type TeamMemberAddToAccountInput = {
  accountId: Scalars['Int']['input'];
  accountRole: Scalars['String']['input'];
  blogRoles: Array<TeamMemberBlogRoleInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  crmSeat: Scalars['Boolean']['input'];
  inviteEmail: Scalars['String']['input'];
};

/** Autogenerated return type of TeamMemberAddToAccount. */
export type TeamMemberAddToAccountPayload = {
  __typename?: 'TeamMemberAddToAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  teamMember?: Maybe<TeamMember>;
};

export type TeamMemberBlogRole = {
  __typename?: 'TeamMemberBlogRole';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  role: TeamMemberBlogRoleValue;
  teamMember: TeamMember;
  teamMemberId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  wpBlog: WpBlog;
  wpBlogId: Scalars['Int']['output'];
};

export type TeamMemberBlogRoleInput = {
  role: Scalars['String']['input'];
  wordpressBlogId: Scalars['Int']['input'];
};

/** Autogenerated input type of TeamMemberBlogRoleUpdate */
export type TeamMemberBlogRoleUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  role: TeamMemberBlogRoleValue;
  teamMemberId: Scalars['Int']['input'];
  wordpressBlogId: Scalars['Int']['input'];
};

/** Autogenerated return type of TeamMemberBlogRoleUpdate. */
export type TeamMemberBlogRoleUpdatePayload = {
  __typename?: 'TeamMemberBlogRoleUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  success: Scalars['Boolean']['output'];
};

export enum TeamMemberBlogRoleValue {
  Administrator = 'administrator',
  Author = 'author',
  Editor = 'editor',
  None = 'none'
}

/** Autogenerated input type of TeamMemberDelete */
export type TeamMemberDeleteInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamMemberId: Scalars['Int']['input'];
};

/** Autogenerated return type of TeamMemberDelete. */
export type TeamMemberDeletePayload = {
  __typename?: 'TeamMemberDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of TeamMemberEdit */
export type TeamMemberEditInput = {
  accountId: Scalars['Int']['input'];
  accountRole: Scalars['String']['input'];
  blogRoles: Array<TeamMemberBlogRoleInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  crmSeat: Scalars['Boolean']['input'];
  teamMemberId: Scalars['Int']['input'];
};

/** Autogenerated return type of TeamMemberEdit. */
export type TeamMemberEditPayload = {
  __typename?: 'TeamMemberEditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  teamMember?: Maybe<TeamMember>;
};

export type TopPagesReport = {
  __typename?: 'TopPagesReport';
  avgEngagementTimePerSession?: Maybe<Scalars['Float']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  conversions: Scalars['Int']['output'];
  page: Scalars['String']['output'];
  pageViewsPerVisitor?: Maybe<Scalars['Float']['output']>;
  visitors: Scalars['Int']['output'];
};

export type TotalVisitorsPerSite = {
  __typename?: 'TotalVisitorsPerSite';
  previousVisitors?: Maybe<Scalars['Int']['output']>;
  subdomain?: Maybe<Scalars['String']['output']>;
  visitors?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of TrackSignup */
export type TrackSignupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  tid: Scalars['String']['input'];
};

/** Autogenerated return type of TrackSignup. */
export type TrackSignupPayload = {
  __typename?: 'TrackSignupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  success?: Maybe<Scalars['JSON']['output']>;
};

export type TrafficAndLeadsDataPoints = {
  __typename?: 'TrafficAndLeadsDataPoints';
  count?: Maybe<Scalars['Int']['output']>;
  date: Scalars['ISO8601Date']['output'];
};

export type TrafficAndLeadsReport = {
  __typename?: 'TrafficAndLeadsReport';
  leads: Array<TrafficAndLeadsDataPoints>;
  totals: TrafficAndLeadsTotals;
  visitors: Array<TrafficAndLeadsDataPoints>;
};

export type TrafficAndLeadsTotals = {
  __typename?: 'TrafficAndLeadsTotals';
  avgSessionTime?: Maybe<Scalars['Float']['output']>;
  avgSessionTimeChange?: Maybe<Scalars['Float']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  conversionRateChange?: Maybe<Scalars['Float']['output']>;
  leadsTotal: Scalars['Float']['output'];
  leadsTotalChange?: Maybe<Scalars['Float']['output']>;
  mobileUsage?: Maybe<Scalars['Float']['output']>;
  visitorsTotal: Scalars['Float']['output'];
  visitorsTotalChange?: Maybe<Scalars['Float']['output']>;
};

export type TrafficSourceReport = {
  __typename?: 'TrafficSourceReport';
  avgEngagementRate?: Maybe<Scalars['Float']['output']>;
  avgEngagementTimePerSession?: Maybe<Scalars['Float']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  conversions: Scalars['Int']['output'];
  eventCount?: Maybe<Scalars['Float']['output']>;
  pageViewsPerVisitor?: Maybe<Scalars['Float']['output']>;
  source: Scalars['String']['output'];
  visitors: Scalars['Int']['output'];
};

export type TwilioApiPhoneNumber = {
  __typename?: 'TwilioApiPhoneNumber';
  isoCountry?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type TwilioCall = {
  __typename?: 'TwilioCall';
  actionItems?: Maybe<Array<Scalars['String']['output']>>;
  answeredBy?: Maybe<Scalars['String']['output']>;
  callScore?: Maybe<Scalars['Int']['output']>;
  callScoreReasoning?: Maybe<Scalars['String']['output']>;
  callStatus?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['Int']['output']>;
  childCall?: Maybe<TwilioCall>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  crmOpportunityId?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  durationInSeconds?: Maybe<Scalars['Int']['output']>;
  fromNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  parentCall?: Maybe<TwilioCall>;
  parentCallId?: Maybe<Scalars['Int']['output']>;
  recordingTwilioId?: Maybe<Scalars['String']['output']>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  toNumber?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Array<Scalars['String']['output']>>;
  twilioId: Scalars['String']['output'];
  twilioSubaccountId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type TwilioNumber = {
  __typename?: 'TwilioNumber';
  active: Scalars['Boolean']['output'];
  campaign?: Maybe<Campaign>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  forwardToNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  phoneNumber: Scalars['String']['output'];
  twilioId?: Maybe<Scalars['String']['output']>;
  twilioSubaccountId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type TwilioSubaccount = {
  __typename?: 'TwilioSubaccount';
  accountId?: Maybe<Scalars['Int']['output']>;
  callTrackingNumbers?: Maybe<Array<TwilioNumber>>;
  calls?: Maybe<Array<TwilioCall>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  texts?: Maybe<Array<TwilioText>>;
  twilioDateCreated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  twilioDateUpdated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  twilioId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of TwilioSubaccountCreate */
export type TwilioSubaccountCreateInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of TwilioSubaccountCreate. */
export type TwilioSubaccountCreatePayload = {
  __typename?: 'TwilioSubaccountCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  twilioSubaccount?: Maybe<TwilioSubaccount>;
};

export type TwilioText = {
  __typename?: 'TwilioText';
  campaignId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  crmOpportunityId?: Maybe<Scalars['String']['output']>;
  fromNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  receivedTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  toNumber?: Maybe<Scalars['String']['output']>;
  twilioId: Scalars['String']['output'];
  twilioSubaccountId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of UnhideAllSiteAuditReportIssueDetails */
export type UnhideAllSiteAuditReportIssueDetailsInput = {
  auditSnapshotId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  issueId: Scalars['Int']['input'];
};

/** Autogenerated return type of UnhideAllSiteAuditReportIssueDetails. */
export type UnhideAllSiteAuditReportIssueDetailsPayload = {
  __typename?: 'UnhideAllSiteAuditReportIssueDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UnhideAllSiteAuditReportIssues */
export type UnhideAllSiteAuditReportIssuesInput = {
  auditSnapshotId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UnhideAllSiteAuditReportIssues. */
export type UnhideAllSiteAuditReportIssuesPayload = {
  __typename?: 'UnhideAllSiteAuditReportIssuesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpcomingInvoicePreview = {
  __typename?: 'UpcomingInvoicePreview';
  invoice: StripeInvoice;
  lineItems: Array<StripeInvoiceLineItem>;
};

/** Autogenerated input type of UpdateSubscription */
export type UpdateSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  items: Array<PriceQuantity>;
  wordpressUserId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateSubscription. */
export type UpdateSubscriptionPayload = {
  __typename?: 'UpdateSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  portalUrl: Scalars['String']['output'];
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  keapId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  superAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  vip?: InputMaybe<Scalars['Boolean']['input']>;
  wordpressUserId: Scalars['Int']['input'];
  wordpressUsername?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpgradeContentProToStandard */
export type UpgradeContentProToStandardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpgradeContentProToStandard. */
export type UpgradeContentProToStandardPayload = {
  __typename?: 'UpgradeContentProToStandardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type User = {
  __typename?: 'User';
  abilities: Array<Ability>;
  accounts: Array<Account>;
  activeAccount?: Maybe<Account>;
  anonymousUser?: Maybe<AnonymousUser>;
  carrotAccountStatus: Scalars['String']['output'];
  carrotCrmConfig?: Maybe<CarrotCrmConfig>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentSubscription?: Maybe<PaySubscription>;
  email: Scalars['String']['output'];
  googleAuthConfigs?: Maybe<GoogleAuthConfig>;
  id: Scalars['Int']['output'];
  intercomUserHash?: Maybe<Scalars['String']['output']>;
  keapId?: Maybe<Scalars['Int']['output']>;
  lastSubscription?: Maybe<PaySubscription>;
  migratedFrom?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onboarding?: Maybe<Onboarding>;
  paySubscriptions: Array<PaySubscription>;
  roles: Array<Role>;
  stripeSubscription?: Maybe<StripeSubscription>;
  superAdmin?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vip: Scalars['Boolean']['output'];
  wordpressUserId: Scalars['Int']['output'];
  wordpressUsername: Scalars['String']['output'];
  wpBlogs: Array<WpBlog>;
};

/** A user-readable error */
export type UserInputError = {
  __typename?: 'UserInputError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type WordpressUserMeta = {
  __typename?: 'WordpressUserMeta';
  error?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['JSON']['output']>;
};

export type WpBlog = {
  __typename?: 'WpBlog';
  /** A boolean indicating whether the WpBlog is archived */
  archived: Scalars['Boolean']['output'];
  /** The category of the WpBlog */
  category?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the WpBlog was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** A boolean indicating whether the WpBlog is deleted */
  deleted: Scalars['Boolean']['output'];
  /** The GoogleAuthConfig that the WpBlog is associated with */
  googleAuthConfig?: Maybe<GoogleAuthConfig>;
  /** The UID of the GoogleAuthConfig that the WpBlog is associated with */
  googleAuthConfigId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the WpBlog */
  id: Scalars['Int']['output'];
  /** The domain that a User has mapped to the WpBlog */
  mappedDomain?: Maybe<Scalars['String']['output']>;
  /** The name of the WpBlog */
  name?: Maybe<Scalars['String']['output']>;
  /** The User who owns the WpBlog */
  owner?: Maybe<User>;
  /** The PaySubscription that the WpBlog is associated with */
  paySubscriptionId?: Maybe<Scalars['Int']['output']>;
  /** The timestamp when the WpBlog was registered */
  registeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  roles: Array<Role>;
  /** Whether the WpBlog needs to have its stats updated */
  statsNeedsUpdate: Scalars['Boolean']['output'];
  /** Whether the WpBlog is currently updating its stats */
  statsUpdating: Scalars['Boolean']['output'];
  /** The subdomain of the WpBlog */
  subdomain?: Maybe<Scalars['String']['output']>;
  /** The TeamMemberBlogRoles associated with the WpBlog */
  teamMemberBlogRoles: Array<TeamMemberBlogRole>;
  /** The TeamMembers associated with the WpBlog */
  teamMembers: Array<TeamMember>;
  /** The timestamp when the WpBlog was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  users: Array<User>;
  /** The WordPress ID of the WpBlog */
  wordpressBlogId: Scalars['Int']['output'];
  wpBlogBacklinkOverviews: Array<WpBlogBacklinkOverview>;
  wpBlogDomainOverviewHistories: Array<WpBlogDomainOverviewHistory>;
};

export type WpBlogBacklink = {
  __typename?: 'WpBlogBacklink';
  anchor?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  externalNum: Scalars['Int']['output'];
  firstSeen?: Maybe<Scalars['ISO8601DateTime']['output']>;
  form: Scalars['Boolean']['output'];
  frame: Scalars['Boolean']['output'];
  image: Scalars['Boolean']['output'];
  imageAlt?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  internalNum: Scalars['Int']['output'];
  lastSeen?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lostlink: Scalars['Boolean']['output'];
  newlink: Scalars['Boolean']['output'];
  nofollow: Scalars['Boolean']['output'];
  pageAscore: Scalars['Int']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  responseCode?: Maybe<Scalars['Int']['output']>;
  sitewide: Scalars['Boolean']['output'];
  sourceSize?: Maybe<Scalars['Int']['output']>;
  sourceTitle?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  targetTitle?: Maybe<Scalars['String']['output']>;
  targetUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WpBlogBacklinkOverview = {
  __typename?: 'WpBlogBacklinkOverview';
  authorityScore: Scalars['Int']['output'];
  backlinkTotal: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  date: Scalars['ISO8601Date']['output'];
  followed: Scalars['Int']['output'];
  form: Scalars['Int']['output'];
  frame: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  image: Scalars['Int']['output'];
  ipClassic: Scalars['Int']['output'];
  ips: Scalars['Int']['output'];
  notFollowed: Scalars['Int']['output'];
  referringDomainTotal: Scalars['Int']['output'];
  referringDomains: Scalars['Int']['output'];
  sponsored: Scalars['Int']['output'];
  text: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userGeneratedContent: Scalars['Int']['output'];
  wpBlogId: Scalars['Int']['output'];
};

export type WpBlogBacklinkOverviewChanges = {
  __typename?: 'WpBlogBacklinkOverviewChanges';
  authorityScoreChange?: Maybe<Scalars['Float']['output']>;
  referringDomainsChange?: Maybe<Scalars['Float']['output']>;
  totalChange?: Maybe<Scalars['Float']['output']>;
};

export type WpBlogBacklinkUpsell = {
  __typename?: 'WpBlogBacklinkUpsell';
  authorityScore: Scalars['Int']['output'];
  backlinks?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  wpBlogId: Scalars['Int']['output'];
};

/** Autogenerated input type of WpBlogCreate */
export type WpBlogCreateInput = {
  blogId: Scalars['Int']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['Int']['input'];
  registeredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  subdomain: Scalars['String']['input'];
};

/** Autogenerated return type of WpBlogCreate. */
export type WpBlogCreatePayload = {
  __typename?: 'WpBlogCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  wpBlog?: Maybe<WpBlog>;
};

export type WpBlogDomainOverviewHistory = {
  __typename?: 'WpBlogDomainOverviewHistory';
  createdAt: Scalars['ISO8601DateTime']['output'];
  date: Scalars['ISO8601Date']['output'];
  id: Scalars['Int']['output'];
  keywordsEightyOneToNinety: Scalars['Int']['output'];
  keywordsElevenToTwenty: Scalars['Int']['output'];
  keywordsFiftyOneToSixty: Scalars['Int']['output'];
  keywordsFortyOneToFifty: Scalars['Int']['output'];
  keywordsFourToTen: Scalars['Int']['output'];
  keywordsNinetyOneAndUp: Scalars['Int']['output'];
  keywordsOneToThree: Scalars['Int']['output'];
  keywordsSeventyOneToEighty: Scalars['Int']['output'];
  keywordsSixtyOneToSeventy: Scalars['Int']['output'];
  keywordsThirtyOneToForty: Scalars['Int']['output'];
  keywordsTwentyOneToThirty: Scalars['Int']['output'];
  organicTraffic: Scalars['Int']['output'];
  totalKeywords: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  wpBlogId: Scalars['Int']['output'];
};

/** Autogenerated input type of WpBlogEdit */
export type WpBlogEditInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  blogId: Scalars['Int']['input'];
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  mappedDomain?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of WpBlogEdit. */
export type WpBlogEditPayload = {
  __typename?: 'WpBlogEditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  wpBlog?: Maybe<WpBlog>;
};

/** Autogenerated input type of WpBlogUpdate */
export type WpBlogUpdateInput = {
  archived: Scalars['Boolean']['input'];
  blogId: Scalars['Int']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleted: Scalars['Boolean']['input'];
  mappedDomain?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['Int']['input'];
  subdomain: Scalars['String']['input'];
};

/** Autogenerated input type of WpBlogUpdateMappedDomain */
export type WpBlogUpdateMappedDomainInput = {
  blogId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mappedDomain?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of WpBlogUpdateMappedDomain. */
export type WpBlogUpdateMappedDomainPayload = {
  __typename?: 'WpBlogUpdateMappedDomainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  wpBlog?: Maybe<WpBlog>;
};

/** Autogenerated return type of WpBlogUpdate. */
export type WpBlogUpdatePayload = {
  __typename?: 'WpBlogUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  wpBlog?: Maybe<WpBlog>;
};

export type AmGraphQlTestQueryQueryVariables = Exact<{
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AmGraphQlTestQueryQuery = { __typename?: 'Query', wpBlog?: { __typename?: 'WpBlog', subdomain?: string | null } | null };

export type AmInfiniteTestQueryQueryVariables = Exact<{
  wordpressBlogId: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type AmInfiniteTestQueryQuery = { __typename?: 'Query', backlinkReport: Array<{ __typename?: 'WpBlogBacklink', sourceTitle?: string | null }> };

export type AmGraphQlTestMutationMutationVariables = Exact<{
  input: StripeCustomerPortalInput;
}>;


export type AmGraphQlTestMutationMutation = { __typename?: 'Mutation', stripeCustomerPortal?: { __typename?: 'StripeCustomerPortalPayload', url?: string | null, errors: Array<{ __typename?: 'UserInputError', message: string }> } | null };

export type WpBlogQueryVariables = Exact<{
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WpBlogQuery = { __typename?: 'Query', wpBlog?: { __typename?: 'WpBlog', wordpressBlogId: number, subdomain?: string | null, mappedDomain?: string | null, category?: string | null, registeredAt?: string | null, owner?: { __typename?: 'User', wordpressUserId: number, wordpressUsername: string } | null, googleAuthConfig?: { __typename?: 'GoogleAuthConfig', id: number } | null } | null };

export type CurrentUserQueryVariables = Exact<{
  wordpressUserId: Scalars['Int']['input'];
}>;


export type CurrentUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, carrotAccountStatus: string, name?: string | null, email: string, createdAt: string, wordpressUserId: number, wordpressUsername: string, intercomUserHash?: string | null, superAdmin?: boolean | null, vip: boolean, activeAccount?: { __typename?: 'Account', id: number, owner: { __typename?: 'User', name?: string | null, carrotAccountStatus: string, carrotCrmConfig?: { __typename?: 'CarrotCrmConfig', id: number, teamId: string } | null }, wpBlogs?: Array<{ __typename?: 'WpBlog', wordpressBlogId: number, name?: string | null, mappedDomain?: string | null, subdomain?: string | null }> | null, twilioSubaccount?: { __typename?: 'TwilioSubaccount', id: number } | null } | null, accounts: Array<{ __typename?: 'Account', id: number, name?: string | null }>, currentSubscription?: { __typename?: 'PaySubscription', status: string, canceledAt?: string | null, pastDueDate?: string | null, pastDueCancelAtDate?: string | null, pendingCancellation: boolean, discount?: { __typename?: 'PaySubscriptionDiscount', endDate?: number | null, startDate: number, coupon: { __typename?: 'Coupon', name?: string | null, duration?: string | null, percentOff?: number | null, amountOff?: number | null } } | null, starter: { __typename?: 'Price', id: number, active: boolean, customerType?: string | null, interval?: string | null, wordpressLabel?: string | null, version?: number | null, product: { __typename?: 'Product', name: string, starter?: boolean | null } }, items: Array<{ __typename?: 'PaySubscriptionItem', quantity: number, price: { __typename?: 'Price', id: number, active: boolean, amount: number, wordpressLabel?: string | null, version?: number | null, product: { __typename?: 'Product', name: string, starter?: boolean | null } } }> } | null, carrotCrmConfig?: { __typename?: 'CarrotCrmConfig', id: number } | null } | null };

export type StripeCustomerPortalMutationVariables = Exact<{
  input: StripeCustomerPortalInput;
}>;


export type StripeCustomerPortalMutation = { __typename?: 'Mutation', stripeCustomerPortal?: { __typename?: 'StripeCustomerPortalPayload', url?: string | null, errors: Array<{ __typename?: 'UserInputError', message: string }> } | null };

export type TeamMemberAbilitiesQueryVariables = Exact<{
  wordpressUserId?: InputMaybe<Scalars['Int']['input']>;
  accountId?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TeamMemberAbilitiesQuery = { __typename?: 'Query', teamMemberAbility?: Array<{ __typename?: 'Ability', action: Array<string>, subject: Array<string>, limitingIds?: Array<number> | null }> | null };

export type TrafficAndLeadsReportQueryVariables = Exact<{
  wordpressBlogId: Scalars['Int']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrafficAndLeadsReportQuery = { __typename?: 'Query', trafficAndLeadsReport: { __typename?: 'TrafficAndLeadsReport', totals: { __typename?: 'TrafficAndLeadsTotals', visitorsTotal: number, visitorsTotalChange?: number | null, leadsTotal: number, leadsTotalChange?: number | null, conversionRate?: number | null, conversionRateChange?: number | null, avgSessionTime?: number | null, avgSessionTimeChange?: number | null, mobileUsage?: number | null }, leads: Array<{ __typename?: 'TrafficAndLeadsDataPoints', date: any, count?: number | null }>, visitors: Array<{ __typename?: 'TrafficAndLeadsDataPoints', date: any, count?: number | null }> } };

export type LandingPageReportQueryVariables = Exact<{
  wordpressBlogId: Scalars['Int']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LandingPageReportQuery = { __typename?: 'Query', landingPageReport: Array<{ __typename?: 'LandingPageReport', landingPage: string, visitors: number, pageViewsPerVisitor?: number | null, avgEngagementTimePerSession?: number | null, conversions: number, conversionRate?: number | null }> };

export type TrafficSourceReportQueryVariables = Exact<{
  wordpressBlogId: Scalars['Int']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrafficSourceReportQuery = { __typename?: 'Query', trafficSourceReport: Array<{ __typename?: 'TrafficSourceReport', source: string, visitors: number }> };

export type BacklinkAnalysisQueryVariables = Exact<{
  wordpressBlogId: Scalars['Int']['input'];
}>;


export type BacklinkAnalysisQuery = { __typename?: 'Query', backlinkProfileReport: { __typename?: 'BacklinkProfileReport', backlinkOverview?: { __typename?: 'WpBlogBacklinkOverview', total: number, authorityScore: number, referringDomains: number } | null, backlinkOverviewChanges?: { __typename?: 'WpBlogBacklinkOverviewChanges', totalChange?: number | null, authorityScoreChange?: number | null, referringDomainsChange?: number | null } | null }, backlinkCategoryReport?: { __typename?: 'WpBlogBacklinkOverview', followed: number, notFollowed: number, sponsored: number, userGeneratedContent: number, text: number, image: number, form: number, frame: number, referringDomainTotal: number, backlinkTotal: number } | null };

export type BacklinksOverTimeQueryVariables = Exact<{
  wordpressBlogId: Scalars['Int']['input'];
  weeksAgo?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BacklinksOverTimeQuery = { __typename?: 'Query', backlinkOverviewReport: Array<{ __typename?: 'WpBlogBacklinkOverview', total: number, date: any }> };

export type BacklinkReportQueryVariables = Exact<{
  wordpressBlogId: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type BacklinkReportQuery = { __typename?: 'Query', backlinkReport: Array<{ __typename?: 'WpBlogBacklink', pageAscore: number, sourceTitle?: string | null, sourceUrl?: string | null, anchor?: string | null, targetUrl?: string | null, nofollow: boolean, form: boolean, frame: boolean, image: boolean, sitewide: boolean, newlink: boolean, lostlink: boolean, externalNum: number, internalNum: number, firstSeen?: string | null, lastSeen?: string | null }> };

export type BacklinkUpsellReportQueryVariables = Exact<{
  wordpressBlogId: Scalars['Int']['input'];
}>;


export type BacklinkUpsellReportQuery = { __typename?: 'Query', wpBlogBacklinkUpsellReport?: { __typename?: 'WpBlogBacklinkUpsell', authorityScore: number, backlinks?: any | null } | null };

export type MembershipManagementQueryVariables = Exact<{
  wordpressUserId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MembershipManagementQuery = { __typename?: 'Query', membershipManagement?: { __typename?: 'MembershipManagement', balance?: number | null, customerPortalUrl?: string | null, cancellationRequestLink?: string | null, paySubscription?: { __typename?: 'PaySubscription', currentPeriodEnd?: string | null, limits: any, usage: any, status: string, items: Array<{ __typename?: 'PaySubscriptionItem', quantity: number, price: { __typename?: 'Price', active: boolean, amount: number, customerType?: string | null, interval?: string | null, version?: number | null, product: { __typename?: 'Product', name: string, starter?: boolean | null } } }>, discount?: { __typename?: 'PaySubscriptionDiscount', endDate?: number | null, coupon: { __typename?: 'Coupon', name?: string | null, percentOff?: number | null, amountOff?: number | null } } | null } | null, payPaymentMethod?: { __typename?: 'PayPaymentMethod', data?: any | null, type?: string | null, billingDetails?: any | null } | null } | null };

export type CancelSubscriptionAtPeriodEndMutationVariables = Exact<{
  input: CancelSubscriptionAtPeriodEndInput;
}>;


export type CancelSubscriptionAtPeriodEndMutation = { __typename?: 'Mutation', cancelSubscriptionAtPeriodEnd?: { __typename?: 'CancelSubscriptionAtPeriodEndPayload', success?: boolean | null, errors: Array<{ __typename?: 'UserInputError', message: string, path?: Array<string> | null }> } | null };

export type WpBlogEditMutationVariables = Exact<{
  input: WpBlogEditInput;
}>;


export type WpBlogEditMutation = { __typename?: 'Mutation', wpBlogEdit?: { __typename?: 'WpBlogEditPayload', errors: Array<string>, wpBlog?: { __typename?: 'WpBlog', wordpressBlogId: number } | null } | null };

export type TwilioSubaccountCreateMutationVariables = Exact<{
  input: TwilioSubaccountCreateInput;
}>;


export type TwilioSubaccountCreateMutation = { __typename?: 'Mutation', twilioSubaccountCreate?: { __typename?: 'TwilioSubaccountCreatePayload', twilioSubaccount?: { __typename?: 'TwilioSubaccount', id: number } | null, errors: Array<{ __typename?: 'UserInputError', message: string }> } | null };

export type AvailableNumbersQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
  areaCode: Scalars['String']['input'];
}>;


export type AvailableNumbersQuery = { __typename?: 'Query', availablePhoneNumbers?: Array<{ __typename?: 'TwilioApiPhoneNumber', phoneNumber: string }> | null };

export type BuyPhoneNumberMutationVariables = Exact<{
  input: PhoneNumberBuyInput;
}>;


export type BuyPhoneNumberMutation = { __typename?: 'Mutation', buyPhoneNumber?: { __typename?: 'PhoneNumberBuyPayload', phoneNumber?: { __typename?: 'TwilioNumber', id: number, campaign?: { __typename?: 'Campaign', id: number } | null } | null, errors: Array<{ __typename?: 'UserInputError', message: string }> } | null };

export type PhoneNumberDestroyMutationVariables = Exact<{
  input: PhoneNumberDestroyInput;
}>;


export type PhoneNumberDestroyMutation = { __typename?: 'Mutation', phoneNumberDestroy?: { __typename?: 'PhoneNumberDestroyPayload', success: boolean, errors: Array<{ __typename?: 'UserInputError', message: string }> } | null };

export type CallTrackingQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
}>;


export type CallTrackingQuery = { __typename?: 'Query', account: { __typename?: 'Account', campaigns?: Array<{ __typename?: 'Campaign', id: number, name?: string | null, wpBlog?: { __typename?: 'WpBlog', mappedDomain?: string | null, subdomain?: string | null } | null }> | null, twilioSubaccount?: { __typename?: 'TwilioSubaccount', callTrackingNumbers?: Array<{ __typename?: 'TwilioNumber', id: number, active: boolean, phoneNumber: string, forwardToNumber?: string | null, campaign?: { __typename?: 'Campaign', id: number } | null }> | null, calls?: Array<{ __typename: 'TwilioCall', id: number, campaignId?: number | null, startTime?: string | null, callStatus?: string | null, fromNumber?: string | null, toNumber?: string | null, durationInSeconds?: number | null, callScore?: number | null, callScoreReasoning?: string | null, summary?: string | null, transcript?: Array<string> | null, crmOpportunityId?: string | null, recordingUrl?: string | null }> | null, texts?: Array<{ __typename: 'TwilioText', id: number, campaignId?: number | null, receivedTime?: string | null, fromNumber?: string | null, toNumber?: string | null, crmOpportunityId?: string | null }> | null } | null } };

export type PhoneNumberEditMutationVariables = Exact<{
  input: PhoneNumberEditInput;
}>;


export type PhoneNumberEditMutation = { __typename?: 'Mutation', phoneNumberEdit?: { __typename?: 'PhoneNumberEditPayload', phoneNumber?: { __typename?: 'TwilioNumber', phoneNumber: string } | null, errors: Array<{ __typename?: 'UserInputError', message: string }> } | null };

export type CarrotCrmOptInUserMutationVariables = Exact<{
  input: CarrotCrmOptInUserInput;
}>;


export type CarrotCrmOptInUserMutation = { __typename?: 'Mutation', carrotCrmOptInUser?: { __typename?: 'CarrotCrmOptInUserPayload', success: boolean } | null };

export type UpgradeContentProToStandardMutationVariables = Exact<{
  input: UpgradeContentProToStandardInput;
}>;


export type UpgradeContentProToStandardMutation = { __typename?: 'Mutation', upgradeContentProToStandard?: { __typename?: 'UpgradeContentProToStandardPayload', success?: boolean | null, errors?: Array<string> | null } | null };

export type LatestInvoiceQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestInvoiceQuery = { __typename?: 'Query', latestInvoice?: { __typename?: 'PayCharge', invoiceId?: string | null, amount: number, items?: Array<{ __typename?: 'StripeInvoiceLineItem', price: { __typename?: 'Price', customerType?: string | null, interval?: string | null, wordpressLabel?: string | null, product: { __typename?: 'Product', name: string, starter?: boolean | null } } }> | null } | null };

export type DomainOverviewQueryVariables = Exact<{
  wordpressBlogId: Scalars['Int']['input'];
}>;


export type DomainOverviewQuery = { __typename?: 'Query', backlinkProfileReport: { __typename?: 'BacklinkProfileReport', backlinkOverview?: { __typename?: 'WpBlogBacklinkOverview', total: number, authorityScore: number, referringDomains: number } | null, backlinkOverviewChanges?: { __typename?: 'WpBlogBacklinkOverviewChanges', totalChange?: number | null, authorityScoreChange?: number | null, referringDomainsChange?: number | null } | null }, backlinkCategoryReport?: { __typename?: 'WpBlogBacklinkOverview', followed: number, notFollowed: number, sponsored: number, userGeneratedContent: number, text: number, image: number, form: number, frame: number, referringDomainTotal: number, backlinkTotal: number } | null, organicProfileReport?: { __typename?: 'OrganicProfileReport', keywords: number, keywordsChange?: number | null, organicVisitors: number, organicVisitorsChange?: number | null } | null };

export type OrganicOverviewReportQueryVariables = Exact<{
  wordpressBlogId: Scalars['Int']['input'];
  weeksAgo?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrganicOverviewReportQuery = { __typename?: 'Query', organicOverviewReport: { __typename?: 'OrganicOverviewReport', domainOverviewHistories?: Array<{ __typename?: 'WpBlogDomainOverviewHistory', date: any, keywordsOneToThree: number, keywordsFourToTen: number, keywordsElevenToTwenty: number, keywordsTwentyOneToThirty: number, keywordsThirtyOneToForty: number, keywordsFortyOneToFifty: number, keywordsFiftyOneToSixty: number, keywordsSixtyOneToSeventy: number, keywordsSeventyOneToEighty: number, keywordsEightyOneToNinety: number, keywordsNinetyOneAndUp: number }> | null, organicVisitors?: Array<{ __typename?: 'TrafficAndLeadsDataPoints', date: any, count?: number | null }> | null } };

export type BacklinkOverviewReportQueryVariables = Exact<{
  wordpressBlogId: Scalars['Int']['input'];
  weeksAgo?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BacklinkOverviewReportQuery = { __typename?: 'Query', backlinkOverviewReport: Array<{ __typename?: 'WpBlogBacklinkOverview', authorityScore: number, referringDomains: number, date: any }> };

export type RelatedKeywordsQueryVariables = Exact<{
  reportType: Report;
  searchTerm: Scalars['String']['input'];
  phraseSearchType?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RelatedKeywordsQuery = { __typename?: 'Query', keywordReport?: { __typename?: 'KeywordReport', reportType: Report, searchTerm: string, phraseSearchType?: string | null, orderBy?: string | null, sortOrder?: string | null, page?: number | null, hasMoreResults?: boolean | null, keywordOverviews?: Array<{ __typename?: 'KeywordOverviews', difficulty?: number | null, phrase: string, volume: number, position?: number | null, traffic?: number | null, url?: string | null }> | null } | null };

export type DomainAuthorityComparisonMutationVariables = Exact<{
  domainAuthorityInput: DomainAuthorityComparisonInput;
}>;


export type DomainAuthorityComparisonMutation = { __typename?: 'Mutation', domainAuthorityComparison?: { __typename?: 'DomainAuthorityComparisonPayload', frictionScore?: number | null, marketAverage?: number | null, nationalAverage?: number | null, errors: Array<string>, domains?: Array<{ __typename?: 'DomainAuthority', authorityScore: number, carrotSite: boolean, position?: number | null, nationalSite: boolean }> | null } | null };

export type CaptureEmailMutationVariables = Exact<{
  input: AddEmailToAnonymousUserInput;
}>;


export type CaptureEmailMutation = { __typename?: 'Mutation', addEmailToAnonymousUser?: { __typename?: 'AddEmailToAnonymousUserPayload', success: boolean } | null };

export type MarketReportMutationVariables = Exact<{
  marketReportInput: MarketReportInput;
}>;


export type MarketReportMutation = { __typename?: 'Mutation', marketReport?: { __typename?: 'MarketReportPayload', errors: Array<string>, targetCity?: (
      { __typename?: 'City' }
      & { ' $fragmentRefs'?: { 'MarketReportCityFragment': MarketReportCityFragment } }
    ) | null, adjacentCities?: Array<(
      { __typename?: 'City' }
      & { ' $fragmentRefs'?: { 'MarketReportCityFragment': MarketReportCityFragment } }
    )> | null } | null };

export type MarketReportCityFragment = { __typename?: 'City', city: string, distance: number, distressedAdjustedN?: number | null, distressedRatioRaw?: number | null, distressedSalesComponentPercentileNew?: number | null, distressedSalesCountRaw?: number | null, flipComponentPercentileNew?: number | null, flipsN?: number | null, flipsRaw: number, homeValue: number, housingUnits: number, housingUnitsLogN?: number | null, lat: number, lng: number, marketDynamicComponentPercentileNew?: number | null, marketDynamicsN?: number | null, opportunityScore: number, rawOpportunityScore?: number | null, overallScorePercentileNew?: number | null, population: number, populationMaturityN?: number | null, salesN?: number | null, stateId: string, totalSalesRaw: number, trafficAndLeadsComponentPercentileNew?: number | null, trafficLeadsIndex?: number | null, marketDynamicsPill?: string | null, populationMaturityPill?: string | null, trafficAndLeadsPill?: string | null, wholesaleFlipsPill?: string | null, keyword1Term?: string | null, keyword1Vol?: number | null, keyword1Kd?: number | null, keyword1Cpc?: number | null, keyword2Term?: string | null, keyword2Vol?: number | null, keyword2Kd?: number | null, keyword2Cpc?: number | null, keyword3Term?: string | null, keyword3Vol?: number | null, keyword3Kd?: number | null, keyword3Cpc?: number | null } & { ' $fragmentName'?: 'MarketReportCityFragment' };

export type StrategyRecommendationsQueryVariables = Exact<{
  cities: Array<MarketScoutCity> | MarketScoutCity;
}>;


export type StrategyRecommendationsQuery = { __typename?: 'Query', strategyRecommendations?: Array<{ __typename?: 'MarketScoutStrategy', city?: string | null, recommendation?: string | null, stateId?: string | null, summary?: string | null }> | null };

export type MembershipEditorQueryVariables = Exact<{
  version?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MembershipEditorQuery = { __typename?: 'Query', membershipEditor?: Array<{ __typename?: 'MembershipEditor', selected: boolean, quantity: number, available: boolean, availabilityErrors: Array<string>, maximum?: number | null, minimum?: number | null, minimumErrors: Array<string>, product: { __typename?: 'Product', id: number, name: string, starter?: boolean | null }, annualPrice: { __typename?: 'Price', id: number, amount: number, interval?: string | null, listTitle?: string | null, marketingList?: Array<string> | null, annualSavings: number, monthlyPrice: number }, monthlyPrice: { __typename?: 'Price', id: number, amount: number, interval?: string | null, listTitle?: string | null, marketingList?: Array<string> | null } }> | null };

export type OnboardingQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingQuery = { __typename?: 'Query', onboarding: { __typename?: 'Onboarding', collaboration?: string | null, companyAddress?: string | null, companyCity?: string | null, companyName?: string | null, companyPhone?: string | null, companyState?: string | null, companyZip?: string | null, experience?: string | null, primaryIndustry?: string | null, primaryIndustries: Array<string>, primaryIndustryFocus?: string | null, primaryIndustryFocuses: any, reference?: string | null, referenceDetails?: string | null } };

export type OnboardingUpdateMutationVariables = Exact<{
  input: OnboardingUpdateInput;
}>;


export type OnboardingUpdateMutation = { __typename?: 'Mutation', onboardingUpdate?: { __typename?: 'OnboardingUpdatePayload', success: boolean, errors: Array<{ __typename?: 'UserInputError', message: string, path?: Array<string> | null }> } | null };

export type CreateAndChargeBundleInvoiceMutationVariables = Exact<{
  input: CreateAndChargeBundleInvoiceInput;
}>;


export type CreateAndChargeBundleInvoiceMutation = { __typename?: 'Mutation', createAndChargeBundleInvoice?: { __typename?: 'CreateAndChargeBundleInvoicePayload', success: boolean, errors?: { __typename?: 'Error', type?: string | null, message?: string | null } | null } | null };

export type CreateAccountMutationVariables = Exact<{
  input: AccountCreationInput;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount?: { __typename?: 'AccountCreationPayload', user?: { __typename?: 'AccountCreated', jwt?: string | null } | null, errors: Array<{ __typename?: 'UserInputError', path?: Array<string> | null, message: string }> } | null };

export type BundleQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type BundleQuery = { __typename?: 'Query', bundle?: { __typename?: 'Bundle', id: number, title: string, subtitle?: string | null, total: string, imageUrl?: string | null, slug: string, confirmationUrl: string, customerType?: string | null, bundleMarketingLineItems: Array<{ __typename?: 'BundleMarketingLineItem', description?: string | null }> } | null };

export type StripeSubscriptionCheckoutMutationVariables = Exact<{
  input: StripeSubscriptionCheckoutInput;
}>;


export type StripeSubscriptionCheckoutMutation = { __typename?: 'Mutation', stripeSubscriptionCheckout?: { __typename?: 'StripeSubscriptionCheckoutPayload', checkoutUrl?: string | null } | null };

export type StripeBundleCheckoutMutationVariables = Exact<{
  input: StripeBundleCheckoutInput;
}>;


export type StripeBundleCheckoutMutation = { __typename?: 'Mutation', stripeBundleCheckout?: { __typename?: 'StripeBundleCheckoutPayload', checkoutUrl?: string | null } | null };

export type SearchPerformanceQueryVariables = Exact<{
  days: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  wordpressBlogId: Scalars['Int']['input'];
}>;


export type SearchPerformanceQuery = { __typename?: 'Query', searchPerformanceHistory?: { __typename?: 'SearchPerformanceHistory', data?: Array<{ __typename?: 'SearchPerformanceHistoryInstance', ctr: number, clicks: number, impressions: number, position: number, date: any }> | null, error?: { __typename?: 'ErrorDetail', type?: string | null, message?: string | null } | null } | null, searchPerformancePageUrl?: { __typename?: 'SearchPerformancePageUrl', data?: Array<{ __typename?: 'SearchPerformancePageUrlInstance', ctr: number, clicks: number, impressions: number, position: number, pageUrl: string }> | null, error?: { __typename?: 'ErrorDetail', type?: string | null, message?: string | null } | null } | null, searchPerformanceQueryString?: { __typename?: 'SearchPerformanceQueryString', data?: Array<{ __typename?: 'SearchPerformanceQueryStringInstance', ctr: number, clicks: number, impressions: number, position: number, queryString: string }> | null, error?: { __typename?: 'ErrorDetail', type?: string | null, message?: string | null } | null } | null };

export type ConsentUrlQueryVariables = Exact<{
  wordpressBlogId: Scalars['Int']['input'];
}>;


export type ConsentUrlQuery = { __typename?: 'Query', searchPerformanceConsentUrl?: { __typename?: 'SearchPerformanceConsentUrl', consentUrl?: string | null, error?: { __typename?: 'ErrorDetail', type?: string | null, message?: string | null } | null } | null };

export type MembershipBuilderQueryVariables = Exact<{
  priceActive?: InputMaybe<Scalars['Boolean']['input']>;
  priceVersion?: InputMaybe<Scalars['Int']['input']>;
  webProductNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  crmProductNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type MembershipBuilderQuery = { __typename?: 'Query', webProducts: Array<{ __typename?: 'Product', id: number, name: string, starter?: boolean | null, prices: Array<{ __typename?: 'Price', id: number, subtitle?: string | null, amount: number, interval?: string | null, listTitle?: string | null, marketingList?: Array<string> | null }> }>, crmProducts: Array<{ __typename?: 'Product', id: number, name: string, prices: Array<{ __typename?: 'Price', id: number, amount: number, interval?: string | null }> }> };

export type SiteAuditReportIssueDetailsQueryVariables = Exact<{
  issueId: Scalars['Int']['input'];
  auditSnapshotId: Scalars['Int']['input'];
}>;


export type SiteAuditReportIssueDetailsQuery = { __typename?: 'Query', siteAuditReportIssueDetails?: { __typename?: 'AuditSnapshot', formattedErrors: Array<(
      { __typename?: 'AuditSnapshotFormattedIssue' }
      & { ' $fragmentRefs'?: { 'FormattedIssueWithDetailsFragment': FormattedIssueWithDetailsFragment } }
    )>, formattedWarnings: Array<(
      { __typename?: 'AuditSnapshotFormattedIssue' }
      & { ' $fragmentRefs'?: { 'FormattedIssueWithDetailsFragment': FormattedIssueWithDetailsFragment } }
    )>, formattedNotices: Array<(
      { __typename?: 'AuditSnapshotFormattedIssue' }
      & { ' $fragmentRefs'?: { 'FormattedIssueWithDetailsFragment': FormattedIssueWithDetailsFragment } }
    )> } | null };

export type FormattedIssueWithDetailsFragment = { __typename?: 'AuditSnapshotFormattedIssue', issueId: string, title: string, titlePage: string, urlColumn: string, infoColumn: string, details: Array<{ __typename?: 'AuditSnapshotFormattedIssueDetail', title: string, discovered: string, sourceUrl: string, targetUrl?: string | null, info?: any | null }> } & { ' $fragmentName'?: 'FormattedIssueWithDetailsFragment' };

export type SiteAuditReportQueryVariables = Exact<{
  wordpressBlogId: Scalars['Int']['input'];
}>;


export type SiteAuditReportQuery = { __typename?: 'Query', siteAuditReport?: { __typename?: 'SiteAuditReport', auditSnapshot?: (
      { __typename?: 'AuditSnapshot', id: number }
      & { ' $fragmentRefs'?: { 'AuditSnapshotFragment': AuditSnapshotFragment } }
    ) | null, auditCampaign?: { __typename?: 'AuditCampaign', lastAudit?: string | null } | null } | null };

export type InitiateAuditMutationVariables = Exact<{
  input: InitiateAuditInput;
}>;


export type InitiateAuditMutation = { __typename?: 'Mutation', initiateAudit?: { __typename?: 'InitiateAuditPayload', success: boolean, errorMessage?: string | null } | null };

export type AuditSnapshotFragment = { __typename?: 'AuditSnapshot', formattedNotices: Array<(
    { __typename?: 'AuditSnapshotFormattedIssue' }
    & { ' $fragmentRefs'?: { 'FormattedIssueFragment': FormattedIssueFragment } }
  )>, formattedWarnings: Array<(
    { __typename?: 'AuditSnapshotFormattedIssue' }
    & { ' $fragmentRefs'?: { 'FormattedIssueFragment': FormattedIssueFragment } }
  )>, formattedErrors: Array<(
    { __typename?: 'AuditSnapshotFormattedIssue' }
    & { ' $fragmentRefs'?: { 'FormattedIssueFragment': FormattedIssueFragment } }
  )> } & { ' $fragmentName'?: 'AuditSnapshotFragment' };

export type FormattedIssueFragment = { __typename: 'AuditSnapshotFormattedIssue', issueId: string, titlePage: string } & { ' $fragmentName'?: 'FormattedIssueFragment' };

export type CreateUpcomingInvoiceMutationVariables = Exact<{
  input: CreateUpcomingInvoiceInput;
}>;


export type CreateUpcomingInvoiceMutation = { __typename?: 'Mutation', createUpcomingInvoice?: { __typename?: 'CreateUpcomingInvoicePayload', upcomingInvoice?: { __typename?: 'UpcomingInvoicePreview', invoice: { __typename?: 'StripeInvoice', tax?: number | null, total: number, periodStart?: string | null }, lineItems: Array<{ __typename?: 'StripeInvoiceLineItem', amount: number, quantity: number, price: { __typename?: 'Price', id: number, active: boolean, customerType?: string | null, interval?: string | null, product: { __typename?: 'Product', name: string, starter?: boolean | null, group?: string | null } } }> } | null, discount?: { __typename?: 'PaySubscriptionDiscount', endDate?: number | null, startDate: number, coupon: { __typename?: 'Coupon', name?: string | null, duration?: string | null, percentOff?: number | null, amountOff?: number | null } } | null, errors: Array<{ __typename?: 'UserInputError', path?: Array<string> | null, message: string }> } | null };

export type PriceByLookupKeyQueryVariables = Exact<{
  lookupKey: Scalars['String']['input'];
}>;


export type PriceByLookupKeyQuery = { __typename?: 'Query', price?: { __typename?: 'Price', id: number, product: { __typename?: 'Product', group?: string | null } } | null };

export type UpdateSubscriptionMutationVariables = Exact<{
  input: UpdateSubscriptionInput;
}>;


export type UpdateSubscriptionMutation = { __typename?: 'Mutation', updateSubscription?: { __typename?: 'UpdateSubscriptionPayload', portalUrl: string, errors: Array<{ __typename?: 'UserInputError', path?: Array<string> | null, message: string }> } | null };

export type SubscriptionUpdateStatusQueryVariables = Exact<{
  wordpressUserId: Scalars['Int']['input'];
}>;


export type SubscriptionUpdateStatusQuery = { __typename?: 'Query', user?: { __typename?: 'User', currentSubscription?: { __typename?: 'PaySubscription', pendingUpdate: boolean } | null } | null };

export type CreateBundleDataQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateBundleDataQuery = { __typename?: 'Query', coupons: Array<{ __typename?: 'Coupon', name?: string | null, processorId?: string | null, id: number, amountOff?: number | null, percentOff?: number | null, duration?: string | null, durationInMonths?: number | null }>, prices: Array<{ __typename?: 'Price', interval?: string | null, amount: number, id: number, stripeId?: string | null, product: { __typename?: 'Product', name: string } }> };

export type CreateBundleMutationVariables = Exact<{
  input: CreateBundleInput;
}>;


export type CreateBundleMutation = { __typename?: 'Mutation', createBundle?: { __typename?: 'CreateBundlePayload', error?: string | null } | null };

export type BundlesQueryVariables = Exact<{ [key: string]: never; }>;


export type BundlesQuery = { __typename?: 'Query', bundles: Array<{ __typename?: 'Bundle', confirmationUrl: string, id: number, imageUrl?: string | null, slug: string, subtitle?: string | null, title: string, total: string, bundleMarketingLineItems: Array<{ __typename?: 'BundleMarketingLineItem', description?: string | null }> }> };

export type UpdateActiveAccountMutationVariables = Exact<{
  input: ActiveAccountUpdateInput;
}>;


export type UpdateActiveAccountMutation = { __typename?: 'Mutation', activeAccountUpdate?: { __typename?: 'ActiveAccountUpdatePayload', errors?: Array<string> | null, activeAccount?: { __typename?: 'Account', id: number } | null } | null };

export type TeamMemberAcceptInviteMutationVariables = Exact<{
  input: TeamMemberAcceptInviteInput;
}>;


export type TeamMemberAcceptInviteMutation = { __typename?: 'Mutation', teamMemberAcceptInvite?: { __typename?: 'TeamMemberAcceptInvitePayload', success: boolean, errors: Array<string>, account?: { __typename?: 'Account', name?: string | null } | null } | null };

export type EditTeamMemberMutationVariables = Exact<{
  input: TeamMemberEditInput;
}>;


export type EditTeamMemberMutation = { __typename?: 'Mutation', teamMemberEdit?: { __typename?: 'TeamMemberEditPayload', teamMember?: (
      { __typename?: 'TeamMember' }
      & { ' $fragmentRefs'?: { 'TeamMemberFragment': TeamMemberFragment } }
    ) | null, errors: Array<{ __typename?: 'UserInputError', path?: Array<string> | null, message: string }> } | null };

export type DeleteTeamMemberMutationVariables = Exact<{
  input: TeamMemberDeleteInput;
}>;


export type DeleteTeamMemberMutation = { __typename?: 'Mutation', teamMemberDelete?: { __typename?: 'TeamMemberDeletePayload', success?: boolean | null, errors: Array<string> } | null };

export type InviteTeamMemberMutationVariables = Exact<{
  input: TeamMemberAddToAccountInput;
}>;


export type InviteTeamMemberMutation = { __typename?: 'Mutation', teamMemberAddToAccount?: { __typename?: 'TeamMemberAddToAccountPayload', teamMember?: (
      { __typename?: 'TeamMember' }
      & { ' $fragmentRefs'?: { 'TeamMemberFragment': TeamMemberFragment } }
    ) | null, errors: Array<{ __typename?: 'UserInputError', path?: Array<string> | null, message: string }> } | null };

export type TeamMembersQueryVariables = Exact<{
  wordpressUserId: Scalars['Int']['input'];
}>;


export type TeamMembersQuery = { __typename?: 'Query', user?: { __typename?: 'User', activeAccount?: { __typename?: 'Account', id: number, owner: { __typename?: 'User', id: number }, teamMembers?: Array<(
        { __typename?: 'TeamMember', id: number }
        & { ' $fragmentRefs'?: { 'TeamMemberFragment': TeamMemberFragment } }
      )> | null, wpBlogs?: Array<{ __typename?: 'WpBlog', id: number, name?: string | null, wordpressBlogId: number, mappedDomain?: string | null, subdomain?: string | null }> | null } | null, currentSubscription?: { __typename?: 'PaySubscription', usage: any, limits: any } | null } | null };

export type TeamMemberFragment = { __typename: 'TeamMember', id: number, accountRole: string, crmSeat: boolean, inviteEmail: string, pending: boolean, blogRoles: Array<{ __typename?: 'TeamMemberBlogRole', wpBlogId: number, role: TeamMemberBlogRoleValue }>, user?: { __typename?: 'User', id: number, name?: string | null, email: string } | null } & { ' $fragmentName'?: 'TeamMemberFragment' };

export const MarketReportCityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketReportCity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"City"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"distressedAdjustedN"}},{"kind":"Field","name":{"kind":"Name","value":"distressedRatioRaw"}},{"kind":"Field","name":{"kind":"Name","value":"distressedSalesComponentPercentileNew"}},{"kind":"Field","name":{"kind":"Name","value":"distressedSalesCountRaw"}},{"kind":"Field","name":{"kind":"Name","value":"flipComponentPercentileNew"}},{"kind":"Field","name":{"kind":"Name","value":"flipsN"}},{"kind":"Field","name":{"kind":"Name","value":"flipsRaw"}},{"kind":"Field","name":{"kind":"Name","value":"homeValue"}},{"kind":"Field","name":{"kind":"Name","value":"housingUnits"}},{"kind":"Field","name":{"kind":"Name","value":"housingUnitsLogN"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"marketDynamicComponentPercentileNew"}},{"kind":"Field","name":{"kind":"Name","value":"marketDynamicsN"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityScore"}},{"kind":"Field","name":{"kind":"Name","value":"rawOpportunityScore"}},{"kind":"Field","name":{"kind":"Name","value":"overallScorePercentileNew"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"populationMaturityN"}},{"kind":"Field","name":{"kind":"Name","value":"salesN"}},{"kind":"Field","name":{"kind":"Name","value":"stateId"}},{"kind":"Field","name":{"kind":"Name","value":"totalSalesRaw"}},{"kind":"Field","name":{"kind":"Name","value":"trafficAndLeadsComponentPercentileNew"}},{"kind":"Field","name":{"kind":"Name","value":"trafficLeadsIndex"}},{"kind":"Field","name":{"kind":"Name","value":"marketDynamicsPill"}},{"kind":"Field","name":{"kind":"Name","value":"populationMaturityPill"}},{"kind":"Field","name":{"kind":"Name","value":"trafficAndLeadsPill"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleFlipsPill"}},{"kind":"Field","name":{"kind":"Name","value":"keyword1Term"}},{"kind":"Field","name":{"kind":"Name","value":"keyword1Vol"}},{"kind":"Field","name":{"kind":"Name","value":"keyword1Kd"}},{"kind":"Field","name":{"kind":"Name","value":"keyword1Cpc"}},{"kind":"Field","name":{"kind":"Name","value":"keyword2Term"}},{"kind":"Field","name":{"kind":"Name","value":"keyword2Vol"}},{"kind":"Field","name":{"kind":"Name","value":"keyword2Kd"}},{"kind":"Field","name":{"kind":"Name","value":"keyword2Cpc"}},{"kind":"Field","name":{"kind":"Name","value":"keyword3Term"}},{"kind":"Field","name":{"kind":"Name","value":"keyword3Vol"}},{"kind":"Field","name":{"kind":"Name","value":"keyword3Kd"}},{"kind":"Field","name":{"kind":"Name","value":"keyword3Cpc"}}]}}]} as unknown as DocumentNode<MarketReportCityFragment, unknown>;
export const FormattedIssueWithDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormattedIssueWithDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuditSnapshotFormattedIssue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titlePage"}},{"kind":"Field","name":{"kind":"Name","value":"urlColumn"}},{"kind":"Field","name":{"kind":"Name","value":"infoColumn"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"discovered"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"targetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"info"}}]}}]}}]} as unknown as DocumentNode<FormattedIssueWithDetailsFragment, unknown>;
export const FormattedIssueFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormattedIssue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuditSnapshotFormattedIssue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"titlePage"}}]}}]} as unknown as DocumentNode<FormattedIssueFragment, unknown>;
export const AuditSnapshotFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuditSnapshot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuditSnapshot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedNotices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedWarnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssue"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormattedIssue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuditSnapshotFormattedIssue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"titlePage"}}]}}]} as unknown as DocumentNode<AuditSnapshotFragment, unknown>;
export const TeamMemberFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamMember"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountRole"}},{"kind":"Field","name":{"kind":"Name","value":"crmSeat"}},{"kind":"Field","name":{"kind":"Name","value":"inviteEmail"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"blogRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wpBlogId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<TeamMemberFragment, unknown>;
export const AmGraphQlTestQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"amGraphQlTestQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wpBlog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subdomain"}}]}}]}}]} as unknown as DocumentNode<AmGraphQlTestQueryQuery, AmGraphQlTestQueryQueryVariables>;
export const AmInfiniteTestQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"amInfiniteTestQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backlinkReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceTitle"}}]}}]}}]} as unknown as DocumentNode<AmInfiniteTestQueryQuery, AmInfiniteTestQueryQueryVariables>;
export const AmGraphQlTestMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"amGraphQlTestMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StripeCustomerPortalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerPortal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<AmGraphQlTestMutationMutation, AmGraphQlTestMutationMutationVariables>;
export const WpBlogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"wpBlog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wpBlog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wordpressBlogId"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"mappedDomain"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"registeredAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wordpressUserId"}},{"kind":"Field","name":{"kind":"Name","value":"wordpressUsername"}}]}},{"kind":"Field","name":{"kind":"Name","value":"googleAuthConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<WpBlogQuery, WpBlogQueryVariables>;
export const CurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"currentUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"carrotAccountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"carrotCrmConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"wpBlogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wordpressBlogId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mappedDomain"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}}]}},{"kind":"Field","name":{"kind":"Name","value":"twilioSubaccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrotAccountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"wordpressUserId"}},{"kind":"Field","name":{"kind":"Name","value":"wordpressUsername"}},{"kind":"Field","name":{"kind":"Name","value":"intercomUserHash"}},{"kind":"Field","name":{"kind":"Name","value":"superAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"vip"}},{"kind":"Field","name":{"kind":"Name","value":"currentSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"canceledAt"}},{"kind":"Field","name":{"kind":"Name","value":"pastDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"pastDueCancelAtDate"}},{"kind":"Field","name":{"kind":"Name","value":"pendingCancellation"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"percentOff"}},{"kind":"Field","name":{"kind":"Name","value":"amountOff"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"starter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"customerType"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"wordpressLabel"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"starter"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"wordpressLabel"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"starter"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrotCrmConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CurrentUserQuery, CurrentUserQueryVariables>;
export const StripeCustomerPortalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"stripeCustomerPortal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StripeCustomerPortalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerPortal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<StripeCustomerPortalMutation, StripeCustomerPortalMutationVariables>;
export const TeamMemberAbilitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"teamMemberAbilities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMemberAbility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"limitingIds"}}]}}]}}]} as unknown as DocumentNode<TeamMemberAbilitiesQuery, TeamMemberAbilitiesQueryVariables>;
export const TrafficAndLeadsReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"trafficAndLeadsReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"days"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trafficAndLeadsReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}},{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitorsTotal"}},{"kind":"Field","name":{"kind":"Name","value":"visitorsTotalChange"}},{"kind":"Field","name":{"kind":"Name","value":"leadsTotal"}},{"kind":"Field","name":{"kind":"Name","value":"leadsTotalChange"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRate"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRateChange"}},{"kind":"Field","name":{"kind":"Name","value":"avgSessionTime"}},{"kind":"Field","name":{"kind":"Name","value":"avgSessionTimeChange"}},{"kind":"Field","name":{"kind":"Name","value":"mobileUsage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visitors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<TrafficAndLeadsReportQuery, TrafficAndLeadsReportQueryVariables>;
export const LandingPageReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"landingPageReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"days"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"landingPageReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}},{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"landingPage"}},{"kind":"Field","name":{"kind":"Name","value":"visitors"}},{"kind":"Field","name":{"kind":"Name","value":"pageViewsPerVisitor"}},{"kind":"Field","name":{"kind":"Name","value":"avgEngagementTimePerSession"}},{"kind":"Field","name":{"kind":"Name","value":"conversions"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRate"}}]}}]}}]} as unknown as DocumentNode<LandingPageReportQuery, LandingPageReportQueryVariables>;
export const TrafficSourceReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"trafficSourceReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"days"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trafficSourceReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}},{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"visitors"}}]}}]}}]} as unknown as DocumentNode<TrafficSourceReportQuery, TrafficSourceReportQueryVariables>;
export const BacklinkAnalysisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"backlinkAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backlinkProfileReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backlinkOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"authorityScore"}},{"kind":"Field","name":{"kind":"Name","value":"referringDomains"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backlinkOverviewChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalChange"}},{"kind":"Field","name":{"kind":"Name","value":"authorityScoreChange"}},{"kind":"Field","name":{"kind":"Name","value":"referringDomainsChange"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"backlinkCategoryReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"followed"}},{"kind":"Field","name":{"kind":"Name","value":"notFollowed"}},{"kind":"Field","name":{"kind":"Name","value":"sponsored"}},{"kind":"Field","name":{"kind":"Name","value":"userGeneratedContent"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"frame"}},{"kind":"Field","name":{"kind":"Name","value":"referringDomainTotal"}},{"kind":"Field","name":{"kind":"Name","value":"backlinkTotal"}}]}}]}}]} as unknown as DocumentNode<BacklinkAnalysisQuery, BacklinkAnalysisQueryVariables>;
export const BacklinksOverTimeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"backlinksOverTime"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weeksAgo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backlinkOverviewReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}},{"kind":"Argument","name":{"kind":"Name","value":"weeksAgo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weeksAgo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]} as unknown as DocumentNode<BacklinksOverTimeQuery, BacklinksOverTimeQueryVariables>;
export const BacklinkReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"backlinkReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backlinkReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageAscore"}},{"kind":"Field","name":{"kind":"Name","value":"sourceTitle"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"anchor"}},{"kind":"Field","name":{"kind":"Name","value":"targetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"nofollow"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"frame"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"sitewide"}},{"kind":"Field","name":{"kind":"Name","value":"newlink"}},{"kind":"Field","name":{"kind":"Name","value":"lostlink"}},{"kind":"Field","name":{"kind":"Name","value":"externalNum"}},{"kind":"Field","name":{"kind":"Name","value":"internalNum"}},{"kind":"Field","name":{"kind":"Name","value":"firstSeen"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeen"}}]}}]}}]} as unknown as DocumentNode<BacklinkReportQuery, BacklinkReportQueryVariables>;
export const BacklinkUpsellReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"backlinkUpsellReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wpBlogBacklinkUpsellReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorityScore"}},{"kind":"Field","name":{"kind":"Name","value":"backlinks"}}]}}]}}]} as unknown as DocumentNode<BacklinkUpsellReportQuery, BacklinkUpsellReportQueryVariables>;
export const MembershipManagementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"membershipManagement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipManagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"customerPortalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationRequestLink"}},{"kind":"Field","name":{"kind":"Name","value":"paySubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"customerType"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"starter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"}},{"kind":"Field","name":{"kind":"Name","value":"usage"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percentOff"}},{"kind":"Field","name":{"kind":"Name","value":"amountOff"}}]}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"payPaymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"billingDetails"}}]}}]}}]}}]} as unknown as DocumentNode<MembershipManagementQuery, MembershipManagementQueryVariables>;
export const CancelSubscriptionAtPeriodEndDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cancelSubscriptionAtPeriodEnd"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CancelSubscriptionAtPeriodEndInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelSubscriptionAtPeriodEnd"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CancelSubscriptionAtPeriodEndMutation, CancelSubscriptionAtPeriodEndMutationVariables>;
export const WpBlogEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"wpBlogEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WpBlogEditInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wpBlogEdit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wpBlog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wordpressBlogId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<WpBlogEditMutation, WpBlogEditMutationVariables>;
export const TwilioSubaccountCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"twilioSubaccountCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TwilioSubaccountCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"twilioSubaccountCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"twilioSubaccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<TwilioSubaccountCreateMutation, TwilioSubaccountCreateMutationVariables>;
export const AvailableNumbersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"availableNumbers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availablePhoneNumbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"areaCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]} as unknown as DocumentNode<AvailableNumbersQuery, AvailableNumbersQueryVariables>;
export const BuyPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"buyPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneNumberBuyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyPhoneNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BuyPhoneNumberMutation, BuyPhoneNumberMutationVariables>;
export const PhoneNumberDestroyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"phoneNumberDestroy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneNumberDestroyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumberDestroy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PhoneNumberDestroyMutation, PhoneNumberDestroyMutationVariables>;
export const CallTrackingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"callTracking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"wpBlog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mappedDomain"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"twilioSubaccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callTrackingNumbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"forwardToNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"callStatus"}},{"kind":"Field","name":{"kind":"Name","value":"fromNumber"}},{"kind":"Field","name":{"kind":"Name","value":"toNumber"}},{"kind":"Field","name":{"kind":"Name","value":"durationInSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"callScore"}},{"kind":"Field","name":{"kind":"Name","value":"callScoreReasoning"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"crmOpportunityId"}},{"kind":"Field","name":{"kind":"Name","value":"recordingUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"texts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"receivedTime"}},{"kind":"Field","name":{"kind":"Name","value":"fromNumber"}},{"kind":"Field","name":{"kind":"Name","value":"toNumber"}},{"kind":"Field","name":{"kind":"Name","value":"crmOpportunityId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CallTrackingQuery, CallTrackingQueryVariables>;
export const PhoneNumberEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"phoneNumberEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneNumberEditInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumberEdit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PhoneNumberEditMutation, PhoneNumberEditMutationVariables>;
export const CarrotCrmOptInUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"carrotCrmOptInUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CarrotCrmOptInUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrotCrmOptInUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CarrotCrmOptInUserMutation, CarrotCrmOptInUserMutationVariables>;
export const UpgradeContentProToStandardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upgradeContentProToStandard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradeContentProToStandardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upgradeContentProToStandard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpgradeContentProToStandardMutation, UpgradeContentProToStandardMutationVariables>;
export const LatestInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"latestInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latestInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerType"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"wordpressLabel"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"starter"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LatestInvoiceQuery, LatestInvoiceQueryVariables>;
export const DomainOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"domainOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backlinkProfileReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backlinkOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"authorityScore"}},{"kind":"Field","name":{"kind":"Name","value":"referringDomains"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backlinkOverviewChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalChange"}},{"kind":"Field","name":{"kind":"Name","value":"authorityScoreChange"}},{"kind":"Field","name":{"kind":"Name","value":"referringDomainsChange"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"backlinkCategoryReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"followed"}},{"kind":"Field","name":{"kind":"Name","value":"notFollowed"}},{"kind":"Field","name":{"kind":"Name","value":"sponsored"}},{"kind":"Field","name":{"kind":"Name","value":"userGeneratedContent"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"frame"}},{"kind":"Field","name":{"kind":"Name","value":"referringDomainTotal"}},{"kind":"Field","name":{"kind":"Name","value":"backlinkTotal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organicProfileReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsChange"}},{"kind":"Field","name":{"kind":"Name","value":"organicVisitors"}},{"kind":"Field","name":{"kind":"Name","value":"organicVisitorsChange"}}]}}]}}]} as unknown as DocumentNode<DomainOverviewQuery, DomainOverviewQueryVariables>;
export const OrganicOverviewReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"organicOverviewReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weeksAgo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organicOverviewReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}},{"kind":"Argument","name":{"kind":"Name","value":"weeksAgo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weeksAgo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"domainOverviewHistories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsOneToThree"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsFourToTen"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsElevenToTwenty"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsTwentyOneToThirty"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsThirtyOneToForty"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsFortyOneToFifty"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsFiftyOneToSixty"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsSixtyOneToSeventy"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsSeventyOneToEighty"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsEightyOneToNinety"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsNinetyOneAndUp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organicVisitors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<OrganicOverviewReportQuery, OrganicOverviewReportQueryVariables>;
export const BacklinkOverviewReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"backlinkOverviewReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weeksAgo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backlinkOverviewReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}},{"kind":"Argument","name":{"kind":"Name","value":"weeksAgo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weeksAgo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorityScore"}},{"kind":"Field","name":{"kind":"Name","value":"referringDomains"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]} as unknown as DocumentNode<BacklinkOverviewReportQuery, BacklinkOverviewReportQueryVariables>;
export const RelatedKeywordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"relatedKeywords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Report"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phraseSearchType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keywordReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportType"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchTerm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}}},{"kind":"Argument","name":{"kind":"Name","value":"phraseSearchType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phraseSearchType"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"searchTerm"}},{"kind":"Field","name":{"kind":"Name","value":"phraseSearchType"}},{"kind":"Field","name":{"kind":"Name","value":"orderBy"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"hasMoreResults"}},{"kind":"Field","name":{"kind":"Name","value":"keywordOverviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"difficulty"}},{"kind":"Field","name":{"kind":"Name","value":"phrase"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"traffic"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<RelatedKeywordsQuery, RelatedKeywordsQueryVariables>;
export const DomainAuthorityComparisonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"domainAuthorityComparison"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domainAuthorityInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DomainAuthorityComparisonInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"domainAuthorityComparison"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domainAuthorityInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frictionScore"}},{"kind":"Field","name":{"kind":"Name","value":"marketAverage"}},{"kind":"Field","name":{"kind":"Name","value":"nationalAverage"}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorityScore"}},{"kind":"Field","name":{"kind":"Name","value":"carrotSite"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"nationalSite"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DomainAuthorityComparisonMutation, DomainAuthorityComparisonMutationVariables>;
export const CaptureEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"captureEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddEmailToAnonymousUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addEmailToAnonymousUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CaptureEmailMutation, CaptureEmailMutationVariables>;
export const MarketReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"marketReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketReportInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarketReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketReportInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetCity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketReportCity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adjacentCities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketReportCity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketReportCity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"City"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"distressedAdjustedN"}},{"kind":"Field","name":{"kind":"Name","value":"distressedRatioRaw"}},{"kind":"Field","name":{"kind":"Name","value":"distressedSalesComponentPercentileNew"}},{"kind":"Field","name":{"kind":"Name","value":"distressedSalesCountRaw"}},{"kind":"Field","name":{"kind":"Name","value":"flipComponentPercentileNew"}},{"kind":"Field","name":{"kind":"Name","value":"flipsN"}},{"kind":"Field","name":{"kind":"Name","value":"flipsRaw"}},{"kind":"Field","name":{"kind":"Name","value":"homeValue"}},{"kind":"Field","name":{"kind":"Name","value":"housingUnits"}},{"kind":"Field","name":{"kind":"Name","value":"housingUnitsLogN"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"marketDynamicComponentPercentileNew"}},{"kind":"Field","name":{"kind":"Name","value":"marketDynamicsN"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityScore"}},{"kind":"Field","name":{"kind":"Name","value":"rawOpportunityScore"}},{"kind":"Field","name":{"kind":"Name","value":"overallScorePercentileNew"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"populationMaturityN"}},{"kind":"Field","name":{"kind":"Name","value":"salesN"}},{"kind":"Field","name":{"kind":"Name","value":"stateId"}},{"kind":"Field","name":{"kind":"Name","value":"totalSalesRaw"}},{"kind":"Field","name":{"kind":"Name","value":"trafficAndLeadsComponentPercentileNew"}},{"kind":"Field","name":{"kind":"Name","value":"trafficLeadsIndex"}},{"kind":"Field","name":{"kind":"Name","value":"marketDynamicsPill"}},{"kind":"Field","name":{"kind":"Name","value":"populationMaturityPill"}},{"kind":"Field","name":{"kind":"Name","value":"trafficAndLeadsPill"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleFlipsPill"}},{"kind":"Field","name":{"kind":"Name","value":"keyword1Term"}},{"kind":"Field","name":{"kind":"Name","value":"keyword1Vol"}},{"kind":"Field","name":{"kind":"Name","value":"keyword1Kd"}},{"kind":"Field","name":{"kind":"Name","value":"keyword1Cpc"}},{"kind":"Field","name":{"kind":"Name","value":"keyword2Term"}},{"kind":"Field","name":{"kind":"Name","value":"keyword2Vol"}},{"kind":"Field","name":{"kind":"Name","value":"keyword2Kd"}},{"kind":"Field","name":{"kind":"Name","value":"keyword2Cpc"}},{"kind":"Field","name":{"kind":"Name","value":"keyword3Term"}},{"kind":"Field","name":{"kind":"Name","value":"keyword3Vol"}},{"kind":"Field","name":{"kind":"Name","value":"keyword3Kd"}},{"kind":"Field","name":{"kind":"Name","value":"keyword3Cpc"}}]}}]} as unknown as DocumentNode<MarketReportMutation, MarketReportMutationVariables>;
export const StrategyRecommendationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"strategyRecommendations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cities"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarketScoutCity"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strategyRecommendations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cities"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"recommendation"}},{"kind":"Field","name":{"kind":"Name","value":"stateId"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}}]} as unknown as DocumentNode<StrategyRecommendationsQuery, StrategyRecommendationsQueryVariables>;
export const MembershipEditorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"membershipEditor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipEditor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"starter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selected"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityErrors"}},{"kind":"Field","name":{"kind":"Name","value":"maximum"}},{"kind":"Field","name":{"kind":"Name","value":"minimum"}},{"kind":"Field","name":{"kind":"Name","value":"minimumErrors"}},{"kind":"Field","name":{"kind":"Name","value":"annualPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"listTitle"}},{"kind":"Field","name":{"kind":"Name","value":"marketingList"}},{"kind":"Field","name":{"kind":"Name","value":"annualSavings"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"listTitle"}},{"kind":"Field","name":{"kind":"Name","value":"marketingList"}}]}}]}}]}}]} as unknown as DocumentNode<MembershipEditorQuery, MembershipEditorQueryVariables>;
export const OnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collaboration"}},{"kind":"Field","name":{"kind":"Name","value":"companyAddress"}},{"kind":"Field","name":{"kind":"Name","value":"companyCity"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"companyPhone"}},{"kind":"Field","name":{"kind":"Name","value":"companyState"}},{"kind":"Field","name":{"kind":"Name","value":"companyZip"}},{"kind":"Field","name":{"kind":"Name","value":"experience"}},{"kind":"Field","name":{"kind":"Name","value":"primaryIndustry"}},{"kind":"Field","name":{"kind":"Name","value":"primaryIndustries"}},{"kind":"Field","name":{"kind":"Name","value":"primaryIndustryFocus"}},{"kind":"Field","name":{"kind":"Name","value":"primaryIndustryFocuses"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"referenceDetails"}}]}}]}}]} as unknown as DocumentNode<OnboardingQuery, OnboardingQueryVariables>;
export const OnboardingUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"onboardingUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OnboardingUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onboardingUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<OnboardingUpdateMutation, OnboardingUpdateMutationVariables>;
export const CreateAndChargeBundleInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAndChargeBundleInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAndChargeBundleInvoiceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAndChargeBundleInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAndChargeBundleInvoiceMutation, CreateAndChargeBundleInvoiceMutationVariables>;
export const CreateAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jwt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAccountMutation, CreateAccountMutationVariables>;
export const BundleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bundle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bundle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"bundleMarketingLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"customerType"}}]}}]}}]} as unknown as DocumentNode<BundleQuery, BundleQueryVariables>;
export const StripeSubscriptionCheckoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"stripeSubscriptionCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StripeSubscriptionCheckoutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeSubscriptionCheckout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutUrl"}}]}}]}}]} as unknown as DocumentNode<StripeSubscriptionCheckoutMutation, StripeSubscriptionCheckoutMutationVariables>;
export const StripeBundleCheckoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"stripeBundleCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StripeBundleCheckoutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeBundleCheckout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutUrl"}}]}}]}}]} as unknown as DocumentNode<StripeBundleCheckoutMutation, StripeBundleCheckoutMutationVariables>;
export const SearchPerformanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchPerformance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"days"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchPerformanceHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"searchPerformancePageUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"pageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"searchPerformanceQueryString"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"queryString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SearchPerformanceQuery, SearchPerformanceQueryVariables>;
export const ConsentUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"consentUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchPerformanceConsentUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ConsentUrlQuery, ConsentUrlQueryVariables>;
export const MembershipBuilderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"membershipBuilder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceActive"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceVersion"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"webProductNames"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"crmProductNames"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"webProducts"},"name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"names"},"value":{"kind":"Variable","name":{"kind":"Name","value":"webProductNames"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"starter"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceActive"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceVersion"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"listTitle"}},{"kind":"Field","name":{"kind":"Name","value":"marketingList"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"crmProducts"},"name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"names"},"value":{"kind":"Variable","name":{"kind":"Name","value":"crmProductNames"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceActive"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceVersion"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}}]}}]}}]}}]} as unknown as DocumentNode<MembershipBuilderQuery, MembershipBuilderQueryVariables>;
export const SiteAuditReportIssueDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"siteAuditReportIssueDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"auditSnapshotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteAuditReportIssueDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"auditSnapshotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"auditSnapshotId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssueWithDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedWarnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssueWithDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedNotices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssueWithDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormattedIssueWithDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuditSnapshotFormattedIssue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titlePage"}},{"kind":"Field","name":{"kind":"Name","value":"urlColumn"}},{"kind":"Field","name":{"kind":"Name","value":"infoColumn"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"discovered"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"targetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"info"}}]}}]}}]} as unknown as DocumentNode<SiteAuditReportIssueDetailsQuery, SiteAuditReportIssueDetailsQueryVariables>;
export const SiteAuditReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"siteAuditReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteAuditReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressBlogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressBlogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auditSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuditSnapshot"}}]}},{"kind":"Field","name":{"kind":"Name","value":"auditCampaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastAudit"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormattedIssue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuditSnapshotFormattedIssue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"titlePage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuditSnapshot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuditSnapshot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedNotices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedWarnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssue"}}]}}]}}]} as unknown as DocumentNode<SiteAuditReportQuery, SiteAuditReportQueryVariables>;
export const InitiateAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"initiateAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InitiateAuditInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initiateAudit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<InitiateAuditMutation, InitiateAuditMutationVariables>;
export const CreateUpcomingInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUpcomingInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUpcomingInvoiceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUpcomingInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upcomingInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"periodStart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"customerType"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"starter"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"percentOff"}},{"kind":"Field","name":{"kind":"Name","value":"amountOff"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateUpcomingInvoiceMutation, CreateUpcomingInvoiceMutationVariables>;
export const PriceByLookupKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"priceByLookupKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lookupKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"lookupKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lookupKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]} as unknown as DocumentNode<PriceByLookupKeyQuery, PriceByLookupKeyQueryVariables>;
export const UpdateSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSubscriptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const SubscriptionUpdateStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"subscriptionUpdateStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pendingUpdate"}}]}}]}}]}}]} as unknown as DocumentNode<SubscriptionUpdateStatusQuery, SubscriptionUpdateStatusQueryVariables>;
export const CreateBundleDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"createBundleData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coupons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bundleable"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"processorId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amountOff"}},{"kind":"Field","name":{"kind":"Name","value":"percentOff"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMonths"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bundleable"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripeId"}}]}}]}}]} as unknown as DocumentNode<CreateBundleDataQuery, CreateBundleDataQueryVariables>;
export const CreateBundleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createBundle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBundleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBundle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<CreateBundleMutation, CreateBundleMutationVariables>;
export const BundlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bundles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bundles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bundleMarketingLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<BundlesQuery, BundlesQueryVariables>;
export const UpdateActiveAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateActiveAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActiveAccountUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeAccountUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateActiveAccountMutation, UpdateActiveAccountMutationVariables>;
export const TeamMemberAcceptInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"teamMemberAcceptInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMemberAcceptInviteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMemberAcceptInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<TeamMemberAcceptInviteMutation, TeamMemberAcceptInviteMutationVariables>;
export const EditTeamMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editTeamMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMemberEditInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMemberEdit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamMember"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamMember"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountRole"}},{"kind":"Field","name":{"kind":"Name","value":"crmSeat"}},{"kind":"Field","name":{"kind":"Name","value":"inviteEmail"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"blogRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wpBlogId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<EditTeamMemberMutation, EditTeamMemberMutationVariables>;
export const DeleteTeamMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTeamMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMemberDeleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMemberDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>;
export const InviteTeamMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"inviteTeamMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMemberAddToAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMemberAddToAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamMember"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamMember"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountRole"}},{"kind":"Field","name":{"kind":"Name","value":"crmSeat"}},{"kind":"Field","name":{"kind":"Name","value":"inviteEmail"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"blogRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wpBlogId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<InviteTeamMemberMutation, InviteTeamMemberMutationVariables>;
export const TeamMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"teamMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamMember"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wpBlogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"wordpressBlogId"}},{"kind":"Field","name":{"kind":"Name","value":"mappedDomain"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usage"}},{"kind":"Field","name":{"kind":"Name","value":"limits"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamMember"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountRole"}},{"kind":"Field","name":{"kind":"Name","value":"crmSeat"}},{"kind":"Field","name":{"kind":"Name","value":"inviteEmail"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"blogRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wpBlogId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<TeamMembersQuery, TeamMembersQueryVariables>;